import {
  Component,
  Injector,
  OnInit,
  OnDestroy,
  NgZone,
  Input,
  HostListener,
  Output,
  EventEmitter
} from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { BsModalService } from "ngx-bootstrap/modal";
import { DialogConfig } from "src/modules/base/components/dialog/dialog-config";
import { DialogRef, DialogModalSize } from "src/modules/base/components/dialog/dialog-ref";
import { UiEngineComponent } from "src/modules/base/components/ui-engine/ui-engine.component";
import { PopupFormComponent } from "src/modules/base/components/popupform/popupform.component";
import { AlertsService } from "src/modules/base/services/alerts.service";
import { AppService } from "src/modules/base/shared/services/app.service";
import { LoaderService } from 'src/modules/base/services/loader.service';
import { ModalSize, SmartModalService } from "src/modules/base/services/smart-modal.service";
import { FollicularChartGridComponent } from '../follicular-chart-grid/follicular-chart-grid.component';
import { DynamicPopUpComponent } from "src/modules/base/components/data-grid/dynamic-pop-up/dynamic-pop-up.component";
import _moment from 'proxies/dayjs';


@Component({
  selector: "app-stimulation-chart",
  templateUrl: "./stimulation-chart.component.html",
  styleUrls: ["./stimulation-chart.component.scss"],
  standalone: false
})
export class StimulationChart extends UiEngineComponent implements OnInit, OnDestroy {
  @Output() closeChart = new EventEmitter<any>();
  gridData: any = {};
  fields: any[] = [];
  fieldsStimulation: any[] = [];
  patientDetails: any;
  apiData: any;
  pageSize = 7;
  moment = _moment;
  totalItems: any;
  currentPageStart = 1;
  fieldsMedication: any[];
  fieldsClinical: any[] = [];
  fieldsSurgery: any[] = [];
  isRadiationTherapy: boolean = false;
  daysCount = ['Day 0', 'Day 1', 'Day 2', 'Day 3', 'Day 4', 'Day 5', 'Day 6', 'Day 7']
  activeTab: any = 'Day 0'
  jsonResource: string;
  items: any[];
  embryoResourceDef: any;
  medication_update_json: any;
  editableGridData: any;
  barcodeConfig: any;
  barcodeBuffer: string = '';
  bufferTimeout: any;
  btnHide: boolean;
  grading_data: any = null;
  cycleStatus = ''
  isStopBtnVisible: boolean = false
  startTime: number;
  dayWiseCards = [];
  isorderBtnVisible: boolean = false;
  activeStatusPopover: any = null;
  activeMenuPopover: any = null;
  activeFlagPopover: any = null;
  toxicityData: any;
  @Input() input: string | undefined;
  @Input() resource: string | undefined;
  @Input() viewOnly: boolean;
  @Input() cycle_no: string | undefined;
  @Input() care_plan_id: string | undefined
  @Input() custom_get_query: string | undefined
  @Input() from_History: boolean;
  @Input() pullableView: boolean;
  patient_protocol: boolean;
  patient_protocol_info: any
  rowClick: any = true
  isChemoTherapy: boolean = false;
  gridSummaryConfig: any = {
    "search": false,
    "print_allowed": false,
    "hideSearchBox": true,
    "noActionRequired": true,
    "selectAllDefault": true
  }
  constructor(
    public injector: Injector,
    public router: Router,
    public route: ActivatedRoute,
    public modal: BsModalService,
    public config: DialogConfig,
    public dialog: DialogRef,
    public alerts: AlertsService,
    public appService: AppService,
    public ngZone: NgZone,
    public loaders: LoaderService,
    public smartModalService: SmartModalService,
  ) {
    super(injector, router, route, modal, undefined, undefined, ngZone);
  }
  changeStimulationDate(a) {
    if (this.pullableView)
      return
    if (a?.data?.name == 'Date of Sitting') {
      // const [day, month, year] = a.data[a.field.name].split('/').map(Number);
      // const date = new Date(year, month - 1, day).getTime();
      let _data = { uhId: this.patientDetails?.uhId, parent_id: this.patient_protocol_info.id, no_of_sittings: a.field.name.split('day')[1], start_date: this.moment(this.gridData["stimulationData"].resource[0]['day' + a.field.name.split('day')[1]], 'DD/MM/YYYY').valueOf(), previous_date: this.moment(this.gridData["stimulationData"].resource[0]['day' + a.field.name.split('day')[1]], 'DD/MM/YYYY').valueOf() }
      let object = {
        resource: "stimulationdaterange",
        action: "ADD",
        layout_type: "simple",
        // getdata: true,
        application: "emr",
        // data: { start_date: date },
        data: _data,
        customButton: {
          "Add": [
            {
              "label": "Submit"
            }
          ]
        }
      }
      this.smartModalService.open(PopupFormComponent, object, "Change Date", ModalSize.Sm).subscribe(data => {
        if (data?.result?.resource?.length > 0) {
          let local = JSON.parse(localStorage.currentChildData)
          this.dataCallForProtocolHeader(local)
          this.getToxicityData(local)
          //this.dataCall()
          this.fieldsMedication = undefined
          setTimeout(() => {
            this.fieldsMedication = this.generateFieldArray(1, true, this.capability(), 'medication');
          }, 1000);
        }
      })
    }
  }

  remarkMarkDoneDataPopUp(day, event) {
    let object = {}
    if (event == 'remarks') {
      object = {
        resource: "remarksstimulation",
        action: "ADD",
        layout_type: "simple",
        // getdata: true,
        application: "emr",
        data: day.data || {},
        customButton: {
          "Add": [
            {
              "label": "Submit"
            }
          ]
        }
      }
    }
    if (event != 'remarks') {
      object = {
        resource: "markdonestimulation",
        action: "ADD",
        layout_type: "simple",
        // getdata: true,
        application: "emr",
        data: day.data || { mark_done: 'Start' },
        customButton: {
          "Add": [
            {
              "label": "Submit"
            }
          ]
        }
      }
    }
    this.smartModalService.open(PopupFormComponent, object, event == 'remarks' ? 'Remarks' : 'Sitting Status', ModalSize.Md).subscribe(data => {
      if (data) {
        this.dataCall();
      }
    })
  }


  oocytesRevieved() {
    this.baseService.getResourceDef('embryo_collection_form', (resource) => {
      this.embryoResourceDef = resource;
    })
  }

  questionValueChanged(event) {
    if (event?.form?.value?.next_date_and_time && this.editableGridData?.length > 0) {
      this.editableGridData.forEach(element => {
        element['next_date_and_time'] = event.form.value.next_date_and_time;
      })
    }
  }

  // stored so it can be removed on destroy (document outlives this component)
  private onDocumentClick = (event: MouseEvent) => {
      const target = event.target as HTMLElement;
      if (target.closest('.remarks') && this.gridData.popUpClose) {
        this.remarkMarkDoneDataPopUp(this.gridData['remarkMarkDoneUpdates'], 'remarks')
        this.gridData.popUpClose = false
      }
      if (target.closest('.sitting_status') && this.gridData.popUpClose) {
        this.remarkMarkDoneDataPopUp(this.gridData['remarkMarkDoneUpdates'], 'sitting_status')
        this.gridData.popUpClose = false
      }
  };

  ngAfterViewInit(): void {
    document.addEventListener('click', this.onDocumentClick);
  }

  popupForUploadDocument(e) {
    let data: any = {}
    let action = "ADD"
    if (e.action.icon.includes("fa fa-eye")) {
      data = { 'resource': [{ documentId: e.editableGrid[e.index].controls['documentId'].value }] }
      action = 'LIST'
    }
    let popObj = {
      'preDefinedData': data,
      "action": action,
      "getdata": true,
      "layout_type": "simple",
      "application": "emr",
      "title": 'Document Upload',
      "size": DialogModalSize.Md,
      "resource": 'upload_documents_grading',
      "customButton": {
        "Add": [
          {
            "label": "button.submit",
            "icon": "fa fa-check"
          }
        ]
      },
      config: {
        "viewAll": false,
        "hideSearchBox": true,
        "allowPagination": false,
        "customButtonsAllowed": false
      }
    }
    this.dialogService.open(PopupFormComponent, popObj).afterClosed.subscribe(response => {
      if (response?.result?.documentId && e?.editableGrid?.[e?.index]?.controls?.['documentId']) {
        e.editableGrid[e.index].controls['documentId'].value = response.result.documentId
        e.editableGrid[e.index].controls['documentId'].setValue(response.result.documentId)
        e.object.controls.editableRows.controls[e.index].controls['documentId'].setValue(response.result.documentId)
        e.object.controls.editableRows.controls[e.index].controls['documentId'].value = response.result.documentId
        if (this.editableGridData[e.index]) {
          this.editableGridData[e.index]['documentId'] = response.result.documentId
        }
      }
    })
  }

  copyRowMain(i, tindex, e) {
    let index = i
    let targetIndex = tindex
    const plan = e.editableGrid[index].controls['plan']?.value;
    const serviceType_code = e.editableGrid[index].controls['serviceType_code'].value
    const serviceItemId = e.editableGrid[index].controls['serviceItemId'].value
    if (e?.editableGrid?.[tindex]?.controls?.grading_status?.value != 'Completed') {
      Object.keys(e.editableGrid[index].controls).forEach(key => {
        if (e.editableGrid[index].controls[key].value != '' && e.editableGrid[index].controls[key].value != undefined && key != 'copy' && key != 'id' && key != 'oocyte_no' && key != 'oocyte_no_text') {
          e.editableGrid[targetIndex].controls[key].setValue(e.editableGrid[index].controls[key].value)
          if (key == "serviceType_code") {
            if (plan == 'Cryo' && serviceType_code) {
              setTimeout(() => {
                e.editableGrid[targetIndex].controls[key].question_component.updateDependentValue(serviceType_code);
              }, 0);
            }
          }
          if (key == "serviceItemId") {
            if (plan == 'Cryo' && serviceItemId) {
              setTimeout(() => {
                e.editableGrid[targetIndex].controls[key].question_component.updateDependentValue(serviceItemId);
              }, 0);
            }
          }
          if (this.editableGridData?.[targetIndex]?.[key] != undefined) {
            this.editableGridData[targetIndex][key] = (e.editableGrid[index].controls[key].value)
          }
        }
        if (e.editableGrid[index].controls?.[key]?.question_component?.question?.disabled != undefined && e.editableGrid[index].controls?.[key]?.question_component?.question?.disabled !== "") {
          e.editableGrid[targetIndex].controls[key].question_component.question.disabled = e.editableGrid[index].controls[key].question_component.question.disabled
        }
      });
      setTimeout(() => {
        const row = e.editableGrid[targetIndex];
        if (plan == 'Cryo') {
          if (serviceItemId) {
            row.controls['serviceItemId'].setValue(serviceItemId);
          }
        }
        else {
          e.editableGrid[targetIndex] = this.removeAdditionalFields(null, row)
        }
      }, 0);
    }
  }

  daysEdit(e) {
    if (e?.question?.key == 'copy') {
      if (e.object?.controls?.['copy']?.value?.length > 0) {
        e.object.controls['copy'].value.forEach(el => {
          let arr = []
          e.editableGrid.forEach((element, index) => {
            if (element.controls['oocyte_no'].value == el.text) {
              arr.push(index)
            }
          });
          arr.forEach(element => {
            this.copyRowMain(e.index, element, e)
          });
        });
      }
    }
    if (e.type == 'decorator_based' && e?.action?.resource != 'clear') {
      this.popupForUploadDocument(e)
    } else if (e?.action?.resource == 'clear' && e.editableGrid?.[e?.index]?.value?.grading_status != 'Completed') {
      Object.keys(e.object.controls.editableRows.controls[e.index].controls).forEach(key => {
        if (key != 'oocyte_no' && key != 'uhId' && key != 'facility_id' && key != 'id' && e.object.controls.editableRows.controls[e.index].controls[key]?.question_component?.question?.disabled != true) {
          e.object.controls.editableRows.controls[e.index].controls[key].setValue("")
          this.editableGridData[e.index][key] = ""
        }
      })
    } else {
      let arr = ['compact_status', 'no_of_cells', 'regularity', 'fragmentation', 'mnb', 'grade', 'heading', 'expansion', 'te', 'icm']
      if (this.activeTab == 'grading_days1' && e?.type == 'field_change' && e?.question?.key == "fertilisation_status" && e?.object?.value?.fertilisation_status == "Unfertilised") {
        e.object.controls['plan'].setValue('Discard')
      }
      if (this.activeTab == 'grading_days2' && arr.includes(e?.question?.key)) {
        let ranking = this.getEmbryoRankingDay2(e?.object?.value?.no_of_cells, e?.object?.value?.regularity, e?.object?.value?.fragmentation, e?.object?.value?.mnb, e?.object?.value?.grade)
        if (ranking != "-1" && e.object.controls['ranking']) {
          e.object.controls['ranking'].setValue(ranking)
        }
      }
      if (this.activeTab == 'grading_days3' && arr.includes(e?.question?.key)) {
        let ranking = this.getEmbryoRankingDay3(e?.object?.value?.compact_status, e?.object?.value?.no_of_cells, e?.object?.value?.regularity, e?.object?.value?.fragmentation, e?.object?.value?.mnb, e?.object?.value?.grade)
        if (ranking != "-1" && e.object.controls['ranking']) {
          e.object.controls['ranking'].setValue(ranking)
        }
      }
      if (this.activeTab == 'grading_days4' && arr.includes(e?.question?.key)) {
        let ranking = this.getEmbryoRankingDay4(e?.object?.value?.heading, e?.object?.value?.grade)
        if (ranking != "-1" && e.object.controls['ranking']) {
          e.object.controls['ranking'].setValue(ranking)
        }
      }
      if (this.activeTab == 'grading_days5' && arr.includes(e?.question?.key)) {
        let ranking = this.getEmbryoRankingDay5(e?.object?.value?.expansion, e?.object?.value?.te, e?.object?.value?.icm, e?.object?.value?.grade)
        if (ranking != "-1" && e.object.controls['ranking']) {
          e.object.controls['ranking'].setValue(ranking)
        }
      }
      if (e?.object?.length > 0) {
        if (this.editableGridData?.length > 0) {
          let nextDateTime = this.editableGridData.filter((x) => x.grading_stage == 'Pending')?.[0]?.next_date_and_time;
          let nextDateTime1 = this.editableGridData.filter((x) => x.grading_stage == 'Skipped')?.[0]?.next_date_and_time;
          let nextDateTime2 = this.editableGridData.filter((x) => x.grading_stage == 'Final')?.[0]?.next_date_and_time;
          e.object.forEach(element => {
            element['next_date_and_time'] = nextDateTime ? nextDateTime:(nextDateTime1 ? nextDateTime1:(nextDateTime2 ? nextDateTime2:this.editableGridData[0]?.next_date_and_time));
          })
        }
        this.editableGridData = e.object
        if (this.editableGridData.length > 0 && this.editableGridData.filter((x) => x.grading_status != 'Completed')?.length == 0) {
          this.btnHide = true
        } else {
          this.btnHide = false
        }
      }
      if (e?.selectedItems?.length > 0) {
        if (this.editableGridData?.length > 0) {
          // e.selectedItems.forEach(element => {
          //   element['next_date_and_time'] = this.editableGridData[0].next_date_and_time;
          // })
          this.applyNextDateTime(e.selectedItems);
        }
        this.editableGridData = e.selectedItems
        // if (this.editableGridData.length > 0 && this.editableGridData.filter((x) => x.grading_status != 'Completed')?.length == 0) {
        //   this.btnHide = true
        // } else {
        //   this.btnHide = false
        // }
        this.updateBtnVisibility();
      }
      else if (e?.type == "searchselect" && (e?.question?.key == "serviceItemId" || e?.question?.key == "priority")) {
        let arr = []
        if (e?.editableGrid.length > 0) {
          e.editableGrid.forEach((ele, i) => {
            //arr[i] = ele.value
            let obj = {}
            Object.keys(ele?.controls).forEach(key => {
              obj[key] = ele?.controls[key]?.value;
            });
            arr[i] = obj;
          })
        }
        if (this.editableGridData?.length > 0) {
          // arr.forEach(element => {
          //   element['next_date_and_time'] = this.editableGridData[0].next_date_and_time;
          // })
          this.applyNextDateTime(arr);
        }
        this.editableGridData = arr
        this.updateBtnVisibility();
      }

    }
  }
  // Helper → update next_date_and_time
   applyNextDateTime(data: any[]) {
    if (!data?.length || !this.editableGridData?.length) return;
    let nextDateTime = this.editableGridData.filter((x) => x.grading_stage == 'Pending')?.[0]?.next_date_and_time;
    let nextDateTime1 = this.editableGridData.filter((x) => x.grading_stage == 'Skipped')?.[0]?.next_date_and_time;
    let nextDateTime2 = this.editableGridData.filter((x) => x.grading_stage == 'Final')?.[0]?.next_date_and_time;
    data.forEach(element => {
      element['next_date_and_time'] = nextDateTime ? nextDateTime : (nextDateTime1 ? nextDateTime1 : (nextDateTime2 ? nextDateTime2 : this.editableGridData[0]?.next_date_and_time));
    })
  }
  // Helper → update button visibility
  updateBtnVisibility() {
    if (this.editableGridData && Array.isArray(this.editableGridData) && this.editableGridData.length > 0 && this.editableGridData.filter((x) => x.grading_status != 'Completed')?.length == 0) {
      this.btnHide = true
    } else {
      this.btnHide = false
    }
  }
  hasActiveTab(activeTab) {
    if (this?.viewOnly) {
      this.activeTab = activeTab;
      sessionStorage.setItem("activeTab", JSON.stringify(activeTab))
      this.apiData = []
      this.getGradingData(activeTab, true)
      return;
    }
    if (!(new Date(this.formComponenet.form.value['next_date_and_time']).setHours(0, 0, 0, 0) > new Date().setHours(0, 0, 0, 0)) || (this.activeTab > activeTab)) {
      this.activeTab = activeTab
      sessionStorage.setItem("activeTab", JSON.stringify(activeTab))
      this.apiData = []
      this.getGradingData(activeTab, true)
    } else if (this.activeTab != activeTab) {
      this.alerts.error("Next visit date alert");
    }
  }

  embryoGrading(json) {
    this.baseService.getResourceDef(json, (resouceDef) => {
      setTimeout(() => {
        this.medication_update_json = resouceDef;
        this.jsonResource = json
      });
    })
  }

  embryoSummary() {
    this.baseService.getResourceDef('embryo_summary', (resource) => {
      this.gridData.embryoSummaryField = resource.list.fields;
      this.gridData.embryoSummaryField.forEach(element => {
        element['format'] = `fn = function(item){ return item.${element.name}}`;
      })
      this.gridData.embryoSummary = true
    })
    let args = `uhId:${this.patientDetails?.uhId}`;
    this.baseService.get("GET_GRADING_SUMMARY", args, "embryo_grading", "emr").subscribe(
      (res: any) => {
        let data = res.resource
        let keysToInclude = {
          plan: "Plan",
          sperm_morphology: "Sperm Morphology",
          denudation: "Denudation",
          stage: "Stage",
          breakage: "Breakage",
          zp: "ZP"
        }
        let desiredOutput = this.transform(data, keysToInclude);
        if (desiredOutput.length > 0) {
          this.gridData.embryoSummaryData =
          {
            resource: desiredOutput
          }
        }
      });
  }

  transform(input, keyDisplayMap) {
    const map = new Map();
    for (const item of input) {
      const oocyteNo = item.oocyte_no_text;
      const dayNum = (item.no_of_day || "").replace(/[^0-9]/g, "");
      const dayKey = `day${dayNum}`;
      const parts = Object.keys(keyDisplayMap)
        .filter(origKey => item[origKey] !== "" && item[origKey] !== null && item[origKey] !== undefined)
        .map(origKey => `<div class ="pb-2"><strong>${keyDisplayMap[origKey]}</strong>:${item[origKey]},`);
      const joined = parts.join("</div>").slice(0, -1)
      if (!map.has(oocyteNo)) map.set(oocyteNo, { oocyte_no_text: oocyteNo });
      if (joined) map.get(oocyteNo)[dayKey] = joined;
    }
    return Array.from(map.values()).sort((a, b) => a.oocyte_no_text - b.oocyte_no_text);
  }

  savePatientDetails(local) {
    this.baseService.get('GET_PATIENT_BY_UHID', 'uhId:' + this.patientDetails.uhId, 'patient', "patient-registration").subscribe(res => {
      if (res && res.resource[0]) {
        this.gridData.patientAllDetails = res.resource[0]
      }
    if (this['input'] == 'embryo_grading_format') {
      this.jsonResource = 'grading_days0'
      this.activeTab = 'grading_days0'
      this.getGradingData()
      this.oocytesRevieved()
      this.embryoGrading('grading_days0')
    } else if (this['input'] == 'embryo_summary') {
      this.embryoSummary()
    } else if (this['input'] == 'et_monitoring_chart') {
      this.dataCall();
      //to decide wether chart will display in view only mode i.e. stop cycle case commenting here
      // this.initializeFields(1);
    } else {
      if (local && this.patient_protocol) {
        this.getToxicityData(local)
        this.dataCallForProtocolHeader(local)
      }
      else {
        this.dataCallForProtocolHeader(local)
        this.dataCall();
      }

      // this.initializeFields(1);
    }
    })
  }

  ngOnInit(): void {
    let local;
    this.gridData.refresh = true
    sessionStorage.setItem("activeTab", JSON.stringify('Day_0'))
    if (this['action']?.action == 'popup_form') {
      this['input'] = 'embryo_grading_format'
      this['historyPopup'] = true
    }
    if (this.router.url.includes('patient-protocol') || this.patient_protocol) {
      this.patient_protocol = true
      local = JSON.parse(localStorage.currentChildData)
      this.pageSize = local.no_of_sittings
      this.patient_protocol_info = local;
      if (local.isProtocolClosed) {
        this.viewOnly = true;
        this.from_History = true;
        this.cycleStatus = "Protocol Deactivated";
        //this.from_History;
      }
    }
    this.startTime = performance.now();
    this.configForCapability()
    if (this.config?.data?.historyData) {
      //console.log(this.config.data)
      if (this.config.data.historyData?.viewOnly && this.config.data.historyData?.custom_get_query && this.config.data.historyData?.cycle_no && this.config.data.historyData?.care_plan_id) {
        if (this.config?.data?.historyData?.from_History) {
          this.from_History = true
        }
        this.viewOnly = this.config.data.historyData.viewOnly
        this.custom_get_query = this.config.data.historyData.custom_get_query;
        this.cycle_no = this.config.data.historyData.cycle_no;
        this.care_plan_id = this.config.data.historyData.care_plan_id
        if (this.config.data.historyData?.resource) {
          this.resource = this.config.data.historyData.resource
        }
        if (this.config.data.historyData?.input) {
          this['input'] = this.config.data.historyData.input
        }
      }
    }
    const data = sessionStorage.getItem('currentData');
    if (data) this.patientDetails = JSON.parse(data);
    this.savePatientDetails(local)
  }

  configForCapability() {
    this.baseService.get("GET_CONFIG", "module_code:emr,config_code:et_monitoring_capability", "facility_config_mapping", "facility-management").subscribe(data => {
      if (data.errCode == 0 && data.resource.length > 0) {
        if (data.resource[0].config_value == "no" && this['input'] == 'et_monitoring_chart') {
          this.gridData['et_monitoring_capability'] = false;
        } else {
          this.gridData['et_monitoring_capability'] = true;
        }
      } else {
        this.gridData['et_monitoring_capability'] = true;
      }
    });
    this.baseService.get("GET_CONFIG", "module_code:emr,config_code:consumption_from_stimulation_chart", "facility_config_mapping", "facility-management").subscribe(data => {
      if (data.errCode == 0 && data.resource.length > 0) {
        if (data.resource[0].config_value == "item_consumption") {
          this.gridData['item_consumption_capability'] = true;
        } else {
          this.gridData['item_consumption_capability'] = false;
        }
      } else {
        this.gridData['item_consumption_capability'] = false;
      }
    })
  }

  dataCallForProtocolHeader(local) {
    if (local?.id) {
      this.baseService.get('GET_BY_ID', 'id:' + local.id, 'patient_assigned_protocols', "emr").subscribe(res => {
        if (res?.resource?.length > 0 && res.resource[0]?.dateMap) {
          let no_of_sitt = res.resource[0].no_of_sittings
          let obj = {}
          obj['name'] = 'Date of Sitting'
          for (let i = 1; i < no_of_sitt + 1; i++) {
            obj[`day${i}`] = this.moment(JSON.parse(res.resource[0]?.dateMap[i])).format('DD/MM/YYYY')
          }
          this.gridData.stimulationDataRow = obj
        }
      })
    }
  }

  ngOnDestroy(): void {
    document.removeEventListener('click', this.onDocumentClick);
    localStorage.removeItem("no_of_days");
    sessionStorage.removeItem('activeTab')
    super.ngOnDestroy();
  }
  getToxicityData(data: any) {
    let args = ''
    // if (data.uhId) {
    //   args = `uhId:${data?.uhId},encounter_id:${data?.encounter_id},protocol_id:${data.protocol_id}`;
    // }
    if (data.uhId) {
      args = `uhId:${data?.uhId},protocol_id:${data.protocol_id}`;
    }
    this.baseService.get("GET_TOXICITY_MONITORING", args, "toxicity_monitoring", "emr").subscribe({
      next: (res: any) => {
        this.toxicityData = res.resource || [];
        this.dataCall()
      },
      error: (err) => {
        this.toxicityData = [];
        this.dataCall()
        //this.finalizeDataCall(resResource);
      }
    });
  }

  toggleBarcode(key: string) {
    if (this.gridData[key].barcodeConfig != undefined) {
      this.gridData[key].barcodeConfig.barcodeScan = !this?.gridData['medicationData']?.barcodeConfig?.barcodeScan;
      if (this.gridData[key].barcodeConfig.barcodeScan) {
        super.setupBarcodeListener(this.barcodeKeydownListener)
      }
    }
  }

  barcodeKeydownListener(event: KeyboardEvent) {
    const getMidnightTime = (timestamp: number): number => {
      const date = new Date(timestamp);
      date.setHours(0, 0, 0, 0);
      return date.getTime();
    }

    const getTodayMidnight = (): number => {
      return getMidnightTime(Date.now());
    }

    const prepareAdministrationData = (item: any, dayKey: string): any => {
      // Get the specific day's medication data based on dayKey (e.g., "day6")
      const dayNumber = dayKey.replace('day', ''); // Extract number from "day6" -> "6"
      const dayIdKey = `id${dayNumber}`; // Create "id6"

      // Get the specific day's medication info
      const dayMedicationInfo = item[dayIdKey];

      if (!dayMedicationInfo) {
        console.error(`No medication data found for ${dayKey}`);
      }

      // Get current user info
      const currentUser = this.appService.getCurrentUser();
      const userType = currentUser?.user_type || '';

      const chartType = this['input'];

      // Prepare administration payload based on the API structure
      let administrationPayload = {
        id: dayMedicationInfo?.id,
        status: dayMedicationInfo?.status,
        stage: dayMedicationInfo?.stage,
        [dayKey]: dayMedicationInfo[dayKey],
        __user_type: userType,
        medication_name: item?.itemName || "",
        uhId: item?.uhId || "",
        date: item?.date || "",
        infusion_order: item?.infusion_order || "",
        encounter_id: item?.encounter_id || "",
        infusion_series: item.infusion_series || "",
        marMedicationId: dayMedicationInfo?.id,
        itemCode: item?.itemCode || "",
        witnessedBy: "",
        comment: "Auto-administered via barcode scan",
        defaultQuantity: item?.defaultQuantity || "",
        volumeStrength: item?.volumeStrength || "",
        is_multidose: false
      };

      // Add chart-specific fields
      if (chartType === 'stimulation_chart') {
        Object.assign(administrationPayload, {
          virification: "manual",
          rightPatient: true,
          rightMedication: true,
          rightDose: true,
          rightRoute: true,
          rightTime: true
        });
      } else if (chartType === 'et_monitoring_chart') {
        Object.assign(administrationPayload, {
          time: item?.time || "",
          virification: "medication",
          batchNo: item?.batchNo || "",
          description: item?.description || "",
          medicineIssued: item?.medicineIssued || "",
          batchNoScan: item?.batchNo || "",
        });
      }

      return administrationPayload;
    };
    const validateMedication = (items: any, hasDay: any) => {

      const midnightTime = getTodayMidnight();
      const midnightTimeOnly = new Date(midnightTime);
      const midnightHours = midnightTimeOnly.getHours() * 3600000 +
        midnightTimeOnly.getMinutes() * 60000 +
        midnightTimeOnly.getSeconds() * 1000;

      let closestItem = null;
      let smallestTimeDifference = Infinity;
      let totalMissed = 0, totalGiven = 0;
      let allGivenFlag = false, allMissedFlag = false, mixedMissedGivenFlag = false;

      items.forEach(item => {
        if (item[hasDay] == "Missed" && item.time) {
          totalMissed++;
        } else if (item[hasDay] == "Given" && item.time) {
          totalGiven++;
        } else if (item[hasDay] == "Pending" && item.time) {
          // Extract only time from epoch milliseconds
          const itemDate = new Date(item.time);
          const itemTimeOnly = itemDate.getHours() * 3600000 +
            itemDate.getMinutes() * 60000 +
            itemDate.getSeconds() * 1000;

          // Calculate time difference with midnight (00:00:00)
          const timeDifference = Math.abs(midnightHours - itemTimeOnly);

          // Find the closest time to midnight
          if (timeDifference < smallestTimeDifference) {
            smallestTimeDifference = timeDifference;
            closestItem = item;
          }
        }
      });

      if (totalMissed == 0 && totalGiven > 0) {
        allGivenFlag = true;
      } else if (totalGiven == 0 && totalMissed > 0) {
        allMissedFlag = true;
      } else if (totalGiven > 0 && totalMissed > 0) {
        mixedMissedGivenFlag = true;
      }


      if (closestItem) {
        // Call administration function
        withoutPopupMedicineAdministration(closestItem, hasDay);
      } else if (allGivenFlag) {
        this.alerts.error("This medicine has already been administered.");
      } else if (allMissedFlag || mixedMissedGivenFlag) {
        this.alerts.error("Please Administer missed medicine manually.");
      } else {
        this.alerts.error("No medicine found for today.");
      }
    }

    const withoutPopupMedicineAdministration = (item: any, dayKey: string) => {
      try {
        if (item?.qoh <= 0) {
          this.alerts.error("Quantity on hand is zero.");
          return;
        }
        const administrationPayload = prepareAdministrationData(item, dayKey);

        let datasource = {
          action: (this.patient_protocol ? "ADMINISTER_MEDICINE" : "ADMINISTER"),
          application: "emr",
          resource: (this['input'] == 'et_monitoring_chart' ? 'embryo_chart_details' : this.patient_protocol ? 'patient_assigned_protocols_details' : 'stimulation_chart_details'),
        }

        this.loader.showSpinner();

        // Call the API to administer medication
        this.formService.baseService.action(
          administrationPayload,
          datasource.action,
          datasource.application,
          datasource.resource
        ).subscribe({
          next: (response: any) => {
            this.loader.hideSpinner();
            if (response.errCode === 0) {
              this.alerts.success("Request successful.");
              this.dataCall();
            } else {
              this.alerts.error(`${response.message || 'Something went wrong.'}`);
            }
          },
          error: (error: any) => {
            console.error(error);
            this.loader.hideSpinner();
          }
        });
      } catch (error) {
        console.error(error);
        this.loader.hideSpinner();
      }
    };

    const findAndGetStockItem = (stockItem: any, currentMedicationData: any) => {
      return currentMedicationData.filter((item) => {
        return (
          (item?.itemCode == stockItem?.itemCode && item?.batchNo?.toLowerCase() == stockItem?.batchNo?.toLowerCase()) ||
          (item?.medicineIssued == stockItem?.itemName && item.batchNo.toLowerCase() == stockItem.batchNo.toLowerCase()) ||
          (item?.itemName == stockItem?.itemName && item?.itemCode == stockItem?.itemCode)
        );
      });
    }

    const getStockByBarcode = (scannedBarcode: string, hasDay: any): any => {
      let obj = {
        args: `barCode:${scannedBarcode}`,
        projectionKeys: ['barCode', 'batchId', 'batchNo', 'itemCode', 'itemName']
      }
      this.formService.baseService.getData(obj, '', "stock", "inventory-management", "SEARCH_STOCK_BY_BARCODE").subscribe({
        next: (response: any) => {
          if (response.errCode == 0 && response?.resource?.length > 0) {
            let items = findAndGetStockItem(response?.resource[0], this?.gridData['medicationData']?.resource);
            if (!items || items?.length <= 0) {
              this.alerts.error('Medicine not found for today.');
              return;
            } else {
              validateMedication(items, hasDay);
            }
          } else {
            console.error(`No medicine found for the Barcode: ${scannedBarcode}.`);
          }
        },
        error: (error: any) => {
          console.error(error);
        }
      });
    }

    const hasCurrentDataStimulationDate = (res: any, totalNoOfDays: number): string | boolean => {
      if (totalNoOfDays == 0) {
        console.error("Total days is zero.");
        return;
      }

      let rowName = (this['input'] == 'et_monitoring_chart' ? 'Date of ET Monitoring' : this.patient_protocol ? 'Date of Sitting' : 'Date of Stimulation')
      let dateOfStimulation = res.find(e => e?.name == rowName);
      if (dateOfStimulation) {
        // Get today's date only (no time)
        const today = new Date();
        today.setHours(0, 0, 0, 0);

        // Parse day1 date from DD/MM/YYYY format
        const day1DateStr = dateOfStimulation.day1;
        if (!day1DateStr || day1DateStr.trim() === '') {
          console.error("Day1 date is empty or invalid.");
          return false;
        }

        const [day1Date, day1Month, day1Year] = day1DateStr.split('/').map(Number);

        // Validate parsed date components
        if (isNaN(day1Date) || isNaN(day1Month) || isNaN(day1Year)) {
          console.error("Invalid date format in day1:", day1DateStr);
          return false;
        }

        // Create day1 Date object (no time)
        const day1 = new Date(day1Year, day1Month - 1, day1Date);
        day1.setHours(0, 0, 0, 0);

        // Calculate difference in days
        const timeDifference = today.getTime() - day1.getTime();
        const daysDifference = Math.floor(timeDifference / (1000 * 60 * 60 * 24));

        if (daysDifference < 0) {
          return false;
        } else if (daysDifference >= 0 && daysDifference < totalNoOfDays) {
          const dayNumber = daysDifference + 1;
          console.log(`Valid day found: day${dayNumber}`);
          return `day${dayNumber}`;
        } else if (daysDifference >= totalNoOfDays) {
          return false;
        }

      }
      return false;
    }

    if (this?.gridData['medicationData']?.barcodeConfig?.barcodeScan) {
      if (event.key === 'Enter') {
        if (this?.barcodeBuffer?.length > 0) {

          let scannedBarcode = this?.barcodeBuffer?.replace('undefined', '').trim();
          this.alerts.info(`Scanned barcode: ${scannedBarcode}`);
          this.barcodeBuffer = '';

          if (this?.gridData['medicationData']?.resource?.length <= 0) {
            this.alerts.error('No medicine available for administration.');
            return;
          }
          let totalNoOfDays = parseInt(this?.gridData['medicationData']?.resource[0]?.total_days || 0);
          let hasDay = hasCurrentDataStimulationDate(this?.gridData['stimulationData']?.resource, totalNoOfDays);
          if (hasDay) {
            getStockByBarcode(scannedBarcode, hasDay);
          } else {
            this.alerts.error("No medicine found for today.");
            return;
          }

        }
        if (this.bufferTimeout) {
          clearTimeout(this.bufferTimeout);
        }
        return;
      }

      if (event.key.length === 1) {
        if (event.key.match(/[a-zA-Z0-9\-_]/)) {
          this.barcodeBuffer += event.key;
        }

        if (this.bufferTimeout) {
          clearTimeout(this.bufferTimeout);
        }

        this.bufferTimeout = setTimeout(() => {
          if (this?.barcodeBuffer?.length > 0) {
            this.barcodeBuffer = '';
          }
        }, 100);
      }
    }
  }


dataCall(filterData?: string, _args: string = "", queryId: string = "GET_ALL_CHART_DETAILS", _resourceMain: string = "", totalItemsKey: string = "total_days"): void {
    let args = `uhId:${this.patientDetails?.uhId}${filterData || ''}`;
    // Protocol callers (e.g. ChemotherapyProtocolComponent.dataCall) pass their own full args - use it instead of the uhId-only default.
    if (this.patient_protocol && _args) {
      args = `${_args}${filterData || ''}`;
    }
    let query = queryId
    this.loader.showSpinner()
    if (this.cycle_no && this.care_plan_id && this.custom_get_query) {
      query = this.custom_get_query
      args = `uhId:${this.patientDetails?.uhId},cycle_no:${this.cycle_no},care_plan_id:${this.care_plan_id}`
    }

    let resourceMain = _resourceMain || (this['input'] == 'et_monitoring_chart' ? 'embryo_chart_details' : 'stimulation_chart_details');
    this.baseService.get(query, args, resourceMain, "emr").subscribe({
      next: res => {
      // backend errCode convention used everywhere else in this file - a 200 response can still carry a business-logic error.
      if (res.errCode == -1 || !res.resource) {
        if (res.errCode == -1) {
          this.alerts.error(res.message || "Something went wrong");
        }
        this.loader.hideSpinner();
        return;
      }
     
        
      // Preserve the current barcode scanner state before overwriting the object
      const currentBarcodeScanState = this?.gridData?.medicationData?.barcodeConfig?.barcodeScan || false;
      this.apiData = res.resource;
      if(this.apiData?.[0]?.['next_date_and_time'] && this.editableGridData?.[0]?.['next_date_and_time']){
        let nextDateTime = this.editableGridData.filter((x) => x.grading_stage == 'Pending')?.[0]?.next_date_and_time;
        let nextDateTime1 = this.editableGridData.filter((x) => x.grading_stage == 'Skipped')?.[0]?.next_date_and_time;
        let nextDateTime2 = this.editableGridData.filter((x) => x.grading_stage == 'Final')?.[0]?.next_date_and_time;
        this.editableGridData[0]['next_date_and_time'] = nextDateTime ? nextDateTime:(nextDateTime1 ? nextDateTime1:(nextDateTime2 ? nextDateTime2:this.editableGridData[0]?.next_date_and_time));
      }
      this.isRadiationTherapy = !!(this.patient_protocol && res.resource?.some(item =>
        item.protocol_type === 'Radiation Therapy' &&
        item.details_type === 'Clinical Request'
      ));
      this.isChemoTherapy = !!(this.patient_protocol && res.resource?.some(item =>
        item.protocol_type === 'Chemotherapy'
      ));
      if (!this.from_History) {
        this.viewOnly = res.resource[0]?.isChartClosed ? res.resource[0]?.isChartClosed : false
        this.cycleStatus = res.resource[0]?.isChartClosed ? "Status: Closed" : ''
        this.isStopBtnVisible = res.resource[0]?.isChartClosed ? false : true
      }
      this.totalItems = res.resource?.[0]?.[totalItemsKey]
      localStorage.setItem('no_of_days', JSON.stringify(this.totalItems));

      this.gridData["medicationData"] = {
        resource: this.dataSettingForMedication(this.filterByType(res.resource, "Medication Request")),
        barcodeConfig: {
          performActionOnScan: true,
          barcodeScan: currentBarcodeScanState
        }
      };

      this.gridData["remarksData"] = {
        resource: this.dataSettingForRemarks(res.resource, 'Remarks', 'treatment_remarks')
      };

      this.gridData["followUpAdvice"] = {
        resource: this.dataSettingForRemarks(res.resource, 'Remarks', 'follow_up_advice')
      };

      this.gridData["markDoneData"] = {
        resource: this.dataSettingForRemarks(res.resource, 'Mark Done', 'mark_done')
      };

      this.gridData["clinicalData"] = {
        resource: this.dataSetting(this.filterByType(res.resource, "Clinical Request"), 'clinical')
      };

      this.gridData["surgeryData"] = {
        resource: this.dataSetting(this.filterByType(res.resource, "Surgery Request"), 'surgery')
      }
      this.stimulationData(res.resource, 1);
      if (this.gridData.refresh) {
        this.initializeFields(1);
        this.gridData.refresh = false
      }
      this.gridData["remarkMarkDoneBtnData"] = {
        resource: this.dataSettingForBtnRemark(res.resource)
      };
      this.dayWiseCards = this.buildDayWiseData();
      //console.log(this.dayWiseCards,"day wise")
      this.loaders.hideSpinner()
      if (this.startTime) {
        requestAnimationFrame(() => {
          const endTime = performance.now();
          const executionTime = (endTime - this.startTime) / 1000;

          console.log(
            '⏱ Stimulation Chart loaded in:',
            executionTime,
            'seconds'
          );
        });
      }
      },
      error: () => this.loader.hideSpinner()
    });
  }


  dataSettingForRemarks(data, event, dataKey) {
    let arr = []
    let obj = {}
    let name = ""
    if (event == 'Remarks') {
      if (dataKey == 'follow_up_advice') {
        name = 'Follow Up Advice'
      } else {
        name = 'Treatment Remarks'
      }
    } else {
      name = 'Sitting Status'
    }
    data = this.filterByType(data, event)
    if (data?.length > 0) {
      data?.forEach(element => {
        if (element.no_of_sittings) {
          element['no_of_days'] = element.no_of_sittings
        }
        const key = `day${element.no_of_days}`;
        obj = {
          ...obj, [key]: element[dataKey] ? element[dataKey] : "",
          name: name
        }
      });
    } else {
      obj = {
        name: name
      }
    }
    arr.push(obj)
    return arr
  }

  statusIconset(item){
      if(item['status']=='Pending' && item['stage'] == 'Pending' && item['isAdministered'] == false && item['isConsumed'] == false){
        return 'Pending'
      } else if(item['status']=='Pending' && item['stage'] == 'Request Sent' && item['isAdministered'] == false && item['isConsumed'] == false){
        return 'Request Sent'
      } else if(item['status']=='Pending' && item['stage'] == 'Consumption Done' && item['isAdministered'] == false && item['isConsumed'] == true){
        return 'Warning'
      }  else if(item['status']=='Missed' && item['stage'] == 'Request Sent' && item['isAdministered'] == false && item['isConsumed'] == false){
        return 'CrossHourglass'
      }  else if(item['status']=='Missed' && item['stage'] == 'Pending' && item['isAdministered'] == false && item['isConsumed'] == false){
        return 'Missed'
      } else if(item['status']=='Missed' && item['stage'] == 'Consumption Done' && item['isAdministered'] == false && item['isConsumed'] == true){
        return 'MissedBlack'
      } else if(item['status']=='Given' && item['stage'] == 'Given' && item['isAdministered'] == true && item['isConsumed'] == true){
        return 'Completed'
      } 
  }

  dataSettingForMedication(data: any[]): any[] {
    data.sort((a, b) => {
      if (a.itemName < b.itemName) return -1;
      if (a.itemName > b.itemName) return 1;
      return 0;
    });
    const mergedMap = new Map<string, any>();
    data.forEach(item => {
      item['patientAllDetails'] = this.gridData.patientAllDetails;
      if (item.no_of_sittings) {
        item['no_of_days'] = item.no_of_sittings
      }
      let time = this.getTime(item.time)
      //const isInfusion = (item.infusion_order == true || item.infusion_order == 'true');
      let key;
      if (this.patient_protocol) {
        key = `${item.itemName}__${time}`;
      }
      else {
        key = item.dosage_frequency_change == true && item.dosage_frequency_order != undefined
          ? `${item.itemName}__${time}__${item.dosage_frequency_order}`
          : `${item.itemName}__${time}`;
      }
       let updatedStatusKey = undefined
      if(this.gridData['item_consumption_capability']){
        updatedStatusKey = this.statusIconset(item)
      }
      const dayKey = `day${item.no_of_days}`;
      if (item?.status) {
        item[dayKey] = (updatedStatusKey?updatedStatusKey:item.status) + [item.infusion_order ? 'infusion' : ''] + [item.order_sent && this['input'] == 'et_monitoring_chart' ? 'ordersent' : ''];
      } else {
        item[dayKey] = ""
      }
      item['initialQty'] = item.quantity
      item[`id${item.no_of_days}`] = {
        id: item.id,
        status: item.status,
        greaterThanCurrentDate: (item.date > new Date().setHours(0, 0, 0, 0)) ? true : false,
        //[dayKey]: item.status,
        medication_name: item.displayName,
        isConsumed:item.isConsumed,
        isAdministered:item.isAdministered,
        // stage: item.stage,
        // order_sent: item.order_sent || false,
        infusion_order: item.infusion_order || false,
        start_time: item.start_time || 0,
        stop_time: item.stop_time || 0,
        pause_time: item.pause_time || 0,
        resume_time: item.resume_time || 0,
        administer_dose: item.administer_dose,
        patientAllDetails: this.gridData.patientAllDetails,
        time_series: item.time_series || [],
        duration: item.duration || 0,
        [dayKey]: updatedStatusKey ? updatedStatusKey:item.status,
        stage: item.stage,
        order_sent: item.order_sent || false,
        administeredBy: item.administeredBy,
        infusion_series: item.infusion_series || "",
        administer_time: item.administer_time,
        uhId: item.uhId,
        encounter_id: item.encounter_id,
        itemCode: item.itemCode,
        itemName: item.itemName,
        time: item.time,
        other: {
          itemFlag: item.itemFlag,
          id: item.id,
          medication_name: item.displayName,
          administeredBy: item.administeredBy,
          administer_time: item.administer_time,
          dosage_form: item.dosage_form,
          dosage_no: item.dosage_no,
          order_sent: item.order_sent || false,
          uhId: item.uhId,
          encounter_id: item.encounter_id,
          itemCode: item.itemCode
        }
      }

      if (mergedMap.has(key)) {
        const existing = mergedMap.get(key);
        existing.initialQty = item.quantity
        existing.quantity = (existing.quantity || 0) + (item.quantity || 0);
        if (item?.status) {
          existing[dayKey] = (updatedStatusKey ? updatedStatusKey:item.status) + [item.infusion_order ? 'infusion' : ''] + [item.order_sent && this['input'] == 'et_monitoring_chart' ? 'ordersent' : ''];
        } else {
          existing[dayKey] = ""
        }
        existing[`id${item.no_of_days}`] = {
          id: item.id,
          status: item.status,
          greaterThanCurrentDate: (item.date > new Date().setHours(0, 0, 0, 0)) ? true : false,
          [dayKey]: updatedStatusKey ? updatedStatusKey:item.status,
          medication_name: item.displayName,
          stage: item.stage,
          isConsumed:item.isConsumed,
          isAdministered:item.isAdministered,
          order_sent: item.order_sent || false,
          infusion_order: item.infusion_order || false,
          start_time: item.start_time || 0,
          stop_time: item.stop_time || 0,
          pause_time: item.pause_time || 0,
          resume_time: item.resume_time || 0,
          administer_dose: item.administer_dose,
          patientAllDetails: this.gridData.patientAllDetails,
          time_series: item.time_series || [],
          duration: item.duration || 0,
          administeredBy: item.administeredBy,
          parent_id: item.parent_id ? item.parent_id : this.patient_protocol_info.id,
          start_date: item.start_date,
          infusion_series: item.infusion_series || "",
          administer_time: item.administer_time,
          uhId: item.uhId,
          encounter_id: item.encounter_id,
          itemCode: item.itemCode,
          itemName: item.itemName,
          time: item.time,
          other: {
            itemFlag: item.itemFlag,
            id: item.id,
            medication_name: item.displayName,
            administeredBy: item.administeredBy,
            infusion_series: item.infusion_series || "",
            administer_time: item.administer_time,
            dosage_form: item.dosage_form,
            dosage_no: item.dosage_no,
            order_sent: item.order_sent || false,
            itemCode: item.itemCode
          }
        }
        // if(this['input'] == 'et_monitoring_chart'){
        //   existing[`id${item.no_of_days}`]['administeredBy']=item.administeredBy;
        //   existing[`id${item.no_of_days}`]['administer_time']=item.administer_time
        // }
      } else {
        const newItem = { ...item };
        if (item?.status) {
          newItem[dayKey] = (updatedStatusKey ? updatedStatusKey:item.status) + [item.infusion_order ? 'infusion' : ''] + [item.order_sent && this['input'] == 'et_monitoring_chart' ? 'ordersent' : ''];
        } else {
          newItem[dayKey] = ""
        }
        newItem['initialQty'] = item.quantity
        newItem[`id${item.no_of_days}`] = {
          id: item.id,
          status: item.status,
          //  greaterThanCurrentDate: (item.date > new Date().setHours(0, 0, 0, 0)) ? true : false,
          [dayKey]: updatedStatusKey ? updatedStatusKey:item.status,
          medication_name: item.displayName,
          order_sent: item.order_sent || false,
          greaterThanCurrentDate: (item.date > new Date().setHours(0, 0, 0, 0)) ? true : false,
          stage: item.stage,
          isConsumed:item.isConsumed,
          isAdministered:item.isAdministered,
          infusion_order: item.infusion_order || false,
          start_time: item.start_time || 0,
          stop_time: item.stop_time || 0,
          pause_time: item.pause_time || 0,
          resume_time: item.resume_time || 0,
          administer_dose: item.administer_dose,
          patientAllDetails: this.gridData.patientAllDetails,
          time_series: item.time_series || [],
          duration: item.duration || 0,
          administeredBy: item.administeredBy,
          parent_id: item.parent_id ? item.parent_id : this.patient_protocol_info.id,
          start_date: item.start_date,
          infusion_series: item.infusion_series || "",
          administer_time: item.administer_time,
          itemCode: item.itemCode,
          itemName: item.itemName,
          time: item.time,
          other: {
            itemFlag: item.itemFlag,
            id: item.id,
            medication_name: item.displayName,
            administeredBy: item.administeredBy,
            infusion_series: item.infusion_series || "",
            administer_time: item.administer_time,
            dosage_form: item.dosage_form,
            dosage_no: item.dosage_no,
            order_sent: item.order_sent || false,
            itemCode: item.itemCode
          }
        }
        // if(this['input'] == 'et_monitoring_chart'){
        //   newItem[`id${item.no_of_days}`]['administeredBy']=item.administeredBy;
        //   newItem[`id${item.no_of_days}`]['administer_time']=item.administer_time
        // }
        mergedMap.set(key, newItem);
      }
    });
    const merged = Array.from(mergedMap.values());
    let previousItemName = "";
    merged.forEach((item, index) => {
      if (item.no_of_sittings) {
        item['no_of_days'] = item.no_of_sittings
      }
      const name = item.itemName;
      const key = `day${item.no_of_days}`;
      item['name'] = name
      let updatedStatusKey = undefined
      if(this.gridData['item_consumption_capability']){
        updatedStatusKey = this.statusIconset(item)
      }
      if (item?.status) {
        item[key] = (updatedStatusKey ? updatedStatusKey:item.status) + [item.infusion_order ? 'infusion' : ''] + [item.order_sent && this['input'] == 'et_monitoring_chart' ? 'ordersent' : ''];
      } else {
        item[key] = ""
      }
      item['uhId'] = item.uhId;
      item['parent_id'] = item.parent_id ? item.parent_id : this.patient_protocol_info.id,
        item['start_date'] = item.start_date
      item['encounter_id'] = item.encounter_id;
      item['itemCode'] = item.itemCode
      item['infusion_order'] = item.infusion_order || false
      item['start_time'] = item.start_time || 0
      item['stop_time'] = item.stop_time || 0
      item['time_series'] = item.time_series || []
      item['duration'] = item.duration || 0
      item['medication_name'] = item.displayName;
      item['isConsumed'] = item.isConsumed;
      item['isAdministered'] = item.isAdministered
      item['other'] = {
        itemFlag: item.itemFlag,
        id: item.id,
        medication_name: item.displayName,
        administeredBy: item.administeredBy,
        infusion_series: item.infusion_series || "",
        administer_time: item.administer_time,
        dosage_form: item.dosage_form,
        dosage_no: item.dosage_no
      }
      if (item.itemName !== previousItemName) {
        item._hide = false;
        item.medicineCount = merged.filter((x) => x.itemName == item.itemName)?.length
        previousItemName = item.itemName;
      } else {
        item._hide = true;
      }
    });
    //console.log('FINAL MERGED DATA', merged);
    return Object.values(merged);
  }

  remarkMarkDoneBtnData(e) {
    if (e?.field?.name) {
      let obj = { day: [e.field.name], data: { uhId: this.patientDetails?.uhId, parent_id: this.patient_protocol_info.id, no_of_sittings: e.field.name.split('day')[1], start_date: this.moment(this.gridData["stimulationData"].resource[0]['day' + e.field.name.split('day')[1]], 'DD/MM/YYYY').valueOf(), previous_date: this.moment(this.gridData["stimulationData"].resource[0]['day' + e.field.name.split('day')[1]], 'DD/MM/YYYY').valueOf() } };
      if (this.apiData?.filter((x) => x.details_type == 'Mark Done' && x.start_date == this.moment(this.gridData["stimulationData"].resource[0]['day' + e.field.name.split('day')[1]], 'DD/MM/YYYY').valueOf())?.length > 0) {
        let markDoneData = this.apiData.filter((x) => x.details_type == 'Mark Done' && x.start_date == this.moment(this.gridData["stimulationData"].resource[0]['day' + e.field.name.split('day')[1]], 'DD/MM/YYYY').valueOf())[0]
        obj.data['mark_done'] = markDoneData.mark_done;
      }
      if (this.apiData?.filter((x) => x.details_type == "Remarks" && x.start_date == this.moment(this.gridData["stimulationData"].resource[0]['day' + e.field.name.split('day')[1]], 'DD/MM/YYYY').valueOf())?.length > 0) {
        let markDoneData = this.apiData.filter((x) => x.details_type == "Remarks" && x.start_date == this.moment(this.gridData["stimulationData"].resource[0]['day' + e.field.name.split('day')[1]], 'DD/MM/YYYY').valueOf())[0]
        obj.data['treatment_remarks'] = markDoneData?.treatment_remarks || "";
        obj.data['follow_up_advice'] = markDoneData?.follow_up_advice || "";
      }
      this.gridData['remarkMarkDoneUpdates'] = obj
    }
    this.gridData.popUpClose = true
  }

  dataSettingForBtnRemark(data) {
    if (this.fields) {
      let markDone = {}
      this.fields.slice(1).forEach((element, index) => {
        markDone[element.name] = "remarkMarkDone"
        // markDone['data'] = {uhId: this.patientDetails?.uhId,parent_id: this.route.snapshot.queryParams.key,no_of_sittings: index+1}
      });
      return [markDone]
    }
  }

  getTime(time) {
    const date = new Date(time);
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    return `${hours}:${minutes}`;
  }
  getTime1(time) {
    const date = new Date(time);
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    const seconds = String(date.getSeconds()).padStart(2, '0');

    return `${hours}:${minutes}:${seconds}`;
  }

  stimulationData(data: any[], pageStart: number): void {
    if (!data?.length) return;
    let stDate = (this['input'] == 'et_monitoring_chart' ? 'chart_start_date' : 'stimulation_date')
    let heading = (this['input'] == 'et_monitoring_chart' ? "Date of ET Monitoring" : (this.patient_protocol ? "Date of Sitting" : "Date of Stimulation"))
    let surgeryHeading = (this['input'] == 'et_monitoring_chart' ? "Date of ET Surgery" : "Date of Surgery")
    const dayMS = 24 * 60 * 60 * 1000;
    let dayGap = dayMS
    let protocolInfo: any = this.patient_protocol_info;
    if (this.patient_protocol && !protocolInfo) {
      try {
        protocolInfo = JSON.parse(localStorage.currentChildData);
      } catch (e) {
        protocolInfo = {};
      }
    }
    const protocolStartDate = Number(protocolInfo?.start_date ?? data[0]?.start_date ?? data[0]?.[stDate]);
    const protocolInterval = Number(protocolInfo?.interval) || 1;
    if (this.patient_protocol) {
      data[0]['stimulation_date'] = protocolStartDate
    }
    let stimulationDate = data[0][stDate] - dayMS + (pageStart - 1) * dayMS;
    const mensesOffset = Math.floor((data[0][stDate] - data[0].lmp) / dayMS);

    const mensesRow = { name: "Day of Menses" };
    let stimRow = { name: heading };
    const toxicityRow = {
      name: 'Toxicity Detail'
    };
    const surgeryDateRow = { ...this.gridData["surgeryData"].resource[0], name: surgeryHeading };
    const surgeryRequests = data?.filter(item => item.details_type === 'Surgery Request') || [];
    const surgeryGroup: { [name: string]: number[] } = {};
    surgeryRequests.forEach(surg => {
      const name = surg.serviceItemName || surg.surgeryName || surg.itemName || surg.displayName || 'Surgery';
      if (!surgeryGroup[name]) {
        surgeryGroup[name] = [];
      }
      const sDate = surg.expected_surgery_date_time || surg.date || surg.service_date;
      if (sDate) {
        const timestamp = Number(sDate);
        if (!surgeryGroup[name].includes(timestamp)) {
          surgeryGroup[name].push(timestamp);
        }
      }
    });

    Object.keys(surgeryGroup).forEach(name => {
      surgeryGroup[name].sort((a, b) => a - b);
    });

    const surgeryBase = (this.gridData["surgeryData"]?.resource && this.gridData["surgeryData"].resource.length > 0)
      ? this.gridData["surgeryData"].resource[0]
      : {};

    const surgeryRows = Object.keys(surgeryGroup).map(name => {
      const rawDates = surgeryGroup[name];
      const formattedDates = rawDates.map(d => this.moment(d).format('DD/MM/YYYY HH:mm:ss'));
      return {
        ...surgeryBase,
        name: name,
        earliestDate: rawDates[0] || 0,
        dates: formattedDates
      };
    });

    surgeryRows.sort((a, b) => a.earliestDate - b.earliestDate);

    const remarkRow = { ...this.gridData["remarksData"].resource[0] }
    const followUpRow = { ...this.gridData["followUpAdvice"].resource[0] }
    const markDoneRow = { ...this.gridData["markDoneData"].resource[0] }
    this.forLoop(pageStart, i => {
      const currentStimulationDate = this.patient_protocol
        ? protocolStartDate + ((i - 1) * protocolInterval * dayMS)
        : (stimulationDate += dayGap);
      mensesRow[`day${i}`] = String(mensesOffset + i);
      stimRow[`day${i}`] = this.moment(currentStimulationDate).format('DD/MM/YYYY');
      surgeryDateRow[`day${i}`] = surgeryDateRow["day" + i] ? this.moment(currentStimulationDate).format('DD/MM/YYYY') : ''
      surgeryRows.forEach(row => {
        row[`day${i}`] = row.dates[i - 1] || '';
      });
      const currentDateOnly =
        new Date(currentStimulationDate)
          .setHours(0, 0, 0, 0);
      const toxicityMatches =
        this.toxicityData?.filter(tox =>
          new Date(tox.sitting_date)
            .setHours(0, 0, 0, 0) === currentDateOnly
        );
      if (toxicityMatches && toxicityMatches.length > 0) {
        toxicityRow[`day${i}`] = toxicityMatches[0].grade; // Fallback for old references

        toxicityRow[`info${i}`] = {
          matches: toxicityMatches
        };
      }
    });
    if (pageStart == 1) {
      this.gridData["surgeryGridData"] = {
        resource: surgeryRows
      };
    }

    if (this.patient_protocol) {
      stimRow = this.gridData.stimulationDataRow
      const resourceArr = [stimRow];
      if (this.patient_protocol) {
        resourceArr.push(surgeryDateRow)
      }
      if (this.toxicityData && this.toxicityData.length > 0) {
        resourceArr.push(toxicityRow);
      }
      this.gridData["stimulationData"] = {
        resource: resourceArr,
      };
      this.gridData["remarksTableData"] = {
        resource: [remarkRow, followUpRow, markDoneRow]
      };
    } else if (this['input'] == 'et_monitoring_chart') {
      this.gridData["stimulationData"] = {
        resource: [mensesRow, stimRow]
      };
    } else {
      this.gridData["stimulationData"] = {
        resource: this.patient_protocol ? [mensesRow, stimRow, surgeryDateRow] : [mensesRow, stimRow]
      };
    }
  }

  initializeFields(startIndex: number): void {
    this.fields = this.generateFieldArray(startIndex, true);
    this.fieldsStimulation = this.generateFieldArray(startIndex, false);
    this.fieldsMedication = this.generateFieldArray(startIndex, true, this.capability(), 'medication');
    this.fieldsClinical = this.generateFieldArray(startIndex, true, this.patient_protocol ? this.clinicalCapability() : undefined, 'clinical');
    if (startIndex == 1) {
      this.fieldsSurgery = this.generateFieldArray(startIndex, false, undefined, 'surgery');
    }
  }

  generateFieldArray(startIndex: number, includeFormat: boolean, capability?, source?): any[] {
    let fields = []
    let label = (this['input'] == 'et_monitoring_chart' ? 'Day of ET Monitoring' : (this.patient_protocol ? 'Date of Sitting' : 'Day of Stimulation'))
    fields = [];
    if (includeFormat && source != 'medication') {
      fields = [{
        heading: label,
        name: "name",
        order: 1,
        class: this.patient_protocol ? 'position-relative remarkMarkDone' : "position-relative follicle-cell",
        buttonList: [
          {
            type: "button",
            "label": "",
            icon: "fa fa-line-chart",
            action: "open_follicle_chart",
            permission_required: false,

            expression: "item && item.hasFolliculogram === true",
            class: "btn btn-primary p-0 ",
            "conditions": [
              {
                expression: "item && item.hasFolliculogram === true"
              }
            ],
          }
        ],
        name_expression: "item",
      }];
    }
    else {
      fields = [{
        heading: label,
        name: "name",
        order: 1,
      }];
    }
    if (source == 'surgery') {
      fields = [{
        heading: "Surgery Name",
        name: "name",
        order: 1,
      }];
    }
    if (source == 'clinical') {
      fields = [{
        heading: "Item Name",
        name: "name",
        order: 1,
        class: this.patient_protocol ? 'position-relative remarkMarkDone' : "position-relative follicle-cell",
        buttonList: [
          {
            type: "button",
            "label": "",
            icon: "fa fa-line-chart",
            action: "open_follicle_chart",
            permission_required: false,
            expression: "item && item.hasFolliculogram === true",
            class: "btn btn-primary p-0 ",
            "conditions": [
              {
                expression: "item && item.hasFolliculogram === true"
              }
            ],
          }
        ],
        name_expression: "item",
      }];
    }
    if (source == 'medication') {
      fields = [{
        heading: "Medication Name",
        name: "name",
        order: 1,
        rowspan: "medicineCount",
        type: "flags",
        class: this.patient_protocol ? "medication-name-cell" : "",
        "expression": "item.itemFlag",
        showField: "item._hide == false",
        "flag": {
          "type": "image",
          "all_condition": true,
          "conditions": [
            {
              "expression": "item!=undefined && item.itemFlag!=undefined && item.itemFlag.length!=undefined && item.itemFlag.length>0",
              "format": "(item)=>{let a='';for(let currentVal of item.itemFlag){a=currentVal.text+','+a} return a.slice(0, -1); }",
              "img": "assets/images/emr/triangle-risk-icon.svg"
            }
          ]
        }
      }, {
        heading: "field.label.time",
        type: "time",
        name: "time",
        order: 2,
      }, {
        heading: "f.l.dosage/infustion_rate",
        name: "dosage_no",
        "commaDisable": true,
        "type": "composite",
        "format": "fn=function(item){if((item.infusion_order == true || item.infusion_order == 'true') && item.infusion_rate != undefined){return `${item.infusion_rate}`+' ml/hr'} else if(item.dosage_no == undefined || item.dosage_no == ''){return `${(item.frequency_custom_pattern.morning==undefined || item.frequency_custom_pattern.morning=='') ? '0-' : item.frequency_custom_pattern.morning+'-'} ${(item.frequency_custom_pattern.afternoon==undefined || item.frequency_custom_pattern.afternoon=='') ? '0-' : item.frequency_custom_pattern.afternoon+'-'} ${(item.frequency_custom_pattern.evening==undefined || item.frequency_custom_pattern.evening=='') ? '0-' : item.frequency_custom_pattern.evening+'-'} ${(item.frequency_custom_pattern.night==undefined || item.frequency_custom_pattern.night=='') ? '0' : item.frequency_custom_pattern.night}`+` ${item.dosage_form}` }else {return `${item.dosage_no}`+` ${item.dosage_form}`}}",
        order: 2,
      }, {
        heading: "field.label.dosage_form",
        name: "dosage_form",
        order: 2,
      }
      ]
      if (this.isChemoTherapy) {
        let add_field = [{
          heading: "f.l.grouping",
          name: "grouping",
          order: 2,
        }, {
          heading: "field.label.sequence",
          name: "sequence",
          order: 2,
        },
        {
          heading: "Infusion Series",
          name: "infusion_series",
          order: 2,
        }]
        fields = [...fields, ...add_field];
      }
    }
    const shouldUseDateHeaders = (source === 'clinical' || source === 'medication')
      && this.patient_protocol
      && (this.isChemoTherapy || this.isRadiationTherapy);

    this.forLoop(startIndex, i => {
      var dateHeading = shouldUseDateHeaders
        ? this.gridData['stimulationData']?.resource?.[0]?.[`day${i}`] || i
        : i;
      if (source === 'medication') {
        dateHeading = 'Day ' + i + " " + this.gridData['stimulationData']?.resource?.[1]?.[`day${i}`];
      }
      const field = {
        heading: dateHeading,
        name: `day${i}`,
        order: i
      };
      if (includeFormat) {
        // field['class_name'] = 'align-items-center';
        field['type'] = "compositehtmlwithclick";
        field['format'] = `fn = function(item){
          if(item.day${i} == "Pendinginfusion" || item.day${i} == "Pendinginfusionordersent"){ 
            return "<div class='d-flex'><img class='new-source-icon-design' src='assets/images/emr/pending-icon.svg'/><img class='new-source-icon-design' src='assets/images/emr/infusion-icon.svg'/></div>"; 
          } else if (item.day${i} == "Holdinfusion" || item.day${i} == "Holdinfusionordersent"){
            return "<div class='d-flex'><img class='new-source-icon-design' src='assets/images/emr/hold-icon.svg'/><img class='new-source-icon-design' src='assets/images/emr/infusion-icon.svg'/></div>"; 
          } else if (item.day${i} == "Missedinfusion" || item.day${i} == "Missedinfusionordersent"){
            return "<div class='d-flex'><img class='new-source-icon-design' src='assets/images/emr/missed-icon.svg'/><img class='new-source-icon-design' src='assets/images/emr/infusion-icon.svg'/></div>"; 
          } else if (item.day${i} == "administerinfusion" || item.day${i} == "administerinfusionordersent"){
            return "<div class='d-flex'><img class='new-source-icon-design' src='assets/images/emr/re-admin-icon.svg'/><img class='new-source-icon-design' src='assets/images/emr/infusion-icon.svg'/></div>"; 
          } else if (item.day${i} == "Giveninfusion" || item.day${i} == "Completedinfusion" || item.day${i} == "Giveninfusionordersent" || item.day${i} == "Completedinfusionordersent"){
            return "<div class='d-flex'><img class='new-source-icon-design' src='assets/images/emr/admin-icon.svg'/><img class='new-source-icon-design' src='assets/images/emr/infusion-icon.svg'/></div>"; 
          } else if(item.day${i} == "Pending"){ 
            return "<div class='d-flex'><img class='new-source-icon-design' src='assets/images/emr/pending-icon.svg'/></div>"; 
          } else if (item.day${i} == "Hold"){
            return "<div class='d-flex'><img class='new-source-icon-design' src='assets/images/emr/hold-icon.svg'/></div>"; 
          } else if (item.day${i} == "Missed"){
            return "<div class='d-flex'><img class='new-source-icon-design' src='assets/images/emr/missed-icon.svg'/></div>"; 
          } else if (item.day${i} == "administer"){
            return "<div class='d-flex'><img class='new-source-icon-design' src='assets/images/emr/re-admin-icon.svg'/></div>"; 
          } else if (item.day${i} == "Given" || item.day${i} == "Completed" || item.day${i} == "Pendingordersent"){
            return "<div class='d-flex'><img class='new-source-icon-design' src='assets/images/emr/admin-icon.svg'/></div>"; 
          } else if (item.day${i} == "remarkMarkDone"){
            return ${this.from_History || this.pullableView ? '""' : `"<div class='d-flex remarks justify-content-center secondary-btn'>Remarks</div> <div class='d-flex justify-content-center mt-2 sitting_status primary-btn'>Sitting Status</div>"`}; 
          } else if (item.day${i} == "Request Sent"){
            return "<div class='d-flex'><img class='new-source-icon-design' src='assets/images/emr/hourglass.svg'/></div>"; 
          } else if (item.day${i} == "Warning"){
            return "<div class='d-flex'><img class='new-source-icon-design' src='assets/images/emr/High-Risk.svg'/></div>"; 
          } else if (item.day${i} == "MissedBlack"){
            return "<div class='d-flex'><img class='new-source-icon-design' src='assets/images/emr/missed.svg'/></div>"; 
          } else if (item.day${i} == "CrossHourglass"){
            return "<div class='d-flex'><img class='new-source-icon-design' src='assets/images/emr/missed.svg'/><img class='new-source-icon-design' src='assets/images/emr/hourglass.svg'/></div>"; 
          }
          return item.day${i}.replace(/ordersent/gi, ""); 
        }`;
        field['attachedValue'] = `day${i}clinical_value`;
        if (this['input'] == 'stimulation_chart' || this.patient_protocol) {
          if (source == 'medication') {
            field['hover_format'] = {
              name: `day${i}`,
              type: "compositehtmlwithclick",
              // expression: `item.day${i} && (item.day${i}.indexOf('Given') > -1 || item.day${i}.indexOf('Completed') > -1)`,
              expression: `item.day${i} == 'Given' || item.day${i} == 'Completed'`,
              format: this['input'] == 'stimulation_chart'
                ? `fn = function(item){ 
                    var d = item['id${i}'] || {};
                    var formatDate = function(dateStr) {
                      if (!dateStr) return '';
                      return new Date(dateStr).toLocaleString('en-IN', { 
                        timeZone: 'Asia/Kolkata', 
                        day: '2-digit', 
                        month: '2-digit', 
                        year: 'numeric', 
                        hour: '2-digit', 
                        minute: '2-digit', 
                        hour12: true 
                      }).replace(',', '');
                    };
                    ${this.patient_protocol
                  ? `if (d.infusion_order == true || d.infusion_order == 'true') {
                           var adminTime = formatDate(d.administer_time);
                           var startTime = formatDate(d.start_time);
                           var stopTime = formatDate(d.stop_time);
                           var durationText = d.duration ? ' (' + (d.duration < 60000 ? Math.round(d.duration / 1000) + ' secs' : Math.round(d.duration / 60000) + ' mins') + ')' : '';
                           var line1 = '<b>Administered By:</b> ' + (d.administeredBy || '-') + (adminTime ? ' (' + adminTime + ')' : '');
                           var line2 = (startTime || stopTime) ? '<br/><b>Infusion:</b> ' + (startTime || '-') + ' to ' + (stopTime || '-') + durationText : '';
                           var pauseResumeLine = '';
                           if (d.time_series && d.time_series.length > 0) {
                             pauseResumeLine = '<br/><b>Pause & Resume:</b>' + d.time_series.map(function(ts, index) {
                               return '<br/>' + (index + 1) + '. ' + formatDate(ts.pause_time) + ' to ' + (ts.continue_time ? formatDate(ts.continue_time) : (d.stop_time ? formatDate(d.stop_time) : 'Ongoing'));
                             }).join('');
                           }
                           return '<div style="pointer-events: none; white-space: nowrap;">' + line1 + line2 + pauseResumeLine + '</div>';
                         } else {
                           return '<div style="pointer-events: none;"><b>Administered By:</b> ' + (d.administeredBy || '-') + (d.administer_time ? '<br/><b>Date Time:</b> ' + new Date(d.administer_time).toLocaleString() : '') + '</div>';
                         }`
                  : `return '<div style="pointer-events: none;"><b>Administered By:</b> ' + (d.administeredBy || '-') + (d.administer_time ? '<br/><b>Date Time:</b> ' + new Date(d.administer_time).toLocaleString() : '') + '</div>';`
                }
                  }`
                : `fn = function(item){
                    var d = item['id${i}'] || {};
                    var formatDate = function(dateStr) {
                      if (!dateStr) return '';
                      return new Date(dateStr).toLocaleString('en-IN', { 
                        timeZone: 'Asia/Kolkata', 
                        day: '2-digit', 
                        month: '2-digit', 
                        year: 'numeric', 
                        hour: '2-digit', 
                        minute: '2-digit', 
                        hour12: true 
                      }).replace(',', '');
                    };
                    ${this.patient_protocol
                  ? `if (d.infusion_order == true || d.infusion_order == 'true') {
                           var adminTime = formatDate(d.administer_time);
                           var startTime = formatDate(d.start_time);
                           var stopTime = formatDate(d.stop_time);
                           var durationText = d.duration ? ' (' + (d.duration < 60000 ? Math.round(d.duration / 1000) + ' secs' : Math.round(d.duration / 60000) + ' mins') + ')' : '';
                           var line1 = '<b>Administered By:</b> ' + (d.administeredBy || '-') + (adminTime ? ' (' + adminTime + ')' : '');
                           var line2 = (startTime || stopTime) ? '<br/><b>Infusion:</b> ' + (startTime || '-') + ' to ' + (stopTime || '-') + durationText : '';
                           var pauseResumeLine = '';
                           if (d.time_series && d.time_series.length > 0) {
                             pauseResumeLine = '<br/><b>Pause & Resume:</b>' + d.time_series.map(function(ts, index) {
                               return '<br/>' + (index + 1) + '. ' + formatDate(ts.pause_time) + ' to ' + (ts.continue_time ? formatDate(ts.continue_time) : (d.stop_time ? formatDate(d.stop_time) : 'Ongoing'));
                             }).join('');
                           }
                           return '<div style="pointer-events: none; white-space: nowrap;">' + line1 + line2 + pauseResumeLine + '</div>';
                         } else {
                           return '<div style="pointer-events: none;"><b>Administered By:</b> ' + (d.administeredBy || '-') + (d.administer_time ? '<br/><b>Date Time:</b> ' + new Date(d.administer_time).toLocaleString() : '') + '</div>';
                         }`
                  : `return '<div style="pointer-events: none;"><b>Administered By:</b> ' + (d.administeredBy || '-') + (d.administer_time ? '<br/><b>Date Time:</b> ' + new Date(d.administer_time).toLocaleString() : '') + '</div>';`
                }
                  }`
            };
          }

          if (source != 'medication') {
            field['class'] = this.patient_protocol ? 'position-relative remarkMarkDone' : "position-relative follicle-cell"
            field['buttonList'] = [
              {
                type: "button",
                "label": "",
                icon: "fa fa-table",
                action: "open_follicle_data",
                permission_required: false,
                params: {
                  day_no: `${i}`
                },
                expression: `item && item.hasFolliculogram === true && (item.day${i} == 'Given' || item.day${i} == 'Completed')`,
                class: "btn btn-primary p-0 ",
                "conditions": [
                  {
                    expression: `item && item.hasFolliculogram === true && (item.day${i} == 'Given' || item.day${i} == 'Completed')`
                  }
                ],
              }
            ]
          }
        }
        field["name_expression"] = "item.id" + `${i}`
        if (capability && !this.viewOnly) {
          //  if (capability) {
          field['config'] = { "showSettings": false, "buttonMenu": !this.gridData['et_monitoring_capability'] ? '' : this.getCapability() }
        }
        field['class_name'] = "justify-content-center text-wrap";
      } else {
        field['commaDisable'] = true;
        field['type'] = "compositehtmlwithclick";
        field['format'] = `fn = function(item){ 
          if(item.info${i} && item.info${i}.matches) {
            return item.info${i}.matches.map(function(m) {
              return m.grade ? m.grade.split('(')[0].trim() : '';
            }).join(', ');
          }
          return item.day${i} ? item.day${i}.split('(')[0].trim() : ''; 
        }`;
        field['class_name'] = "justify-content-center text-wrap";
        field['hover_format'] = {
          name: `day${i}`,
          type: "compositehtmlwithclick",
          expression: `item && item.name == 'Toxicity Detail' && (item.day${i} != null && item.day${i} !== '' || (item.info${i} && item.info${i}.matches && item.info${i}.matches.length > 0))`,
          format: `fn = function(item){ 
            if (item.info${i} && item.info${i}.matches) {
              return '<div>' + item.info${i}.matches.map(function(m) {
                return (m.grade ? '<b>' + m.grade + '</b>' : '') + (m.grade_info ? '<br>' + m.grade_info : '');
              }).join('<br><br>') + '</div>';
            }
            return '<div>' + (item.day${i} ? '<b>' + item.day${i} + '</b>' : '') + (item.info${i} && item.info${i}.grade_info ? '<br>' + item.info${i}.grade_info : '') + '</div>'; 
          }`
        };
      }
      fields.push(field);
    });
    //if (capability && !this.viewOnly) {
    if (capability && this.gridData['et_monitoring_capability'] && !this.pullableView) {
      fields.push({
        "heading": "",
        "name": "",
        "order": fields.length + 1,
        "sortable": false,
        "config": {
          "type": "ellipse",
          "buttonMenu": !this.viewOnly ? this.checkPermission(capability) : []
        }
      })
    }
    return fields;
  }

  medicationForm(): void {
    let parent_id = this.apiData?.[0]?.parent_id || this.apiData?.[0]?.id;
    let uhId = this.patientDetails?.uhId || this.apiData?.[0]?.uhId;
    //chartType travels with this dialog's own data instead of localStorage's CurrentResource,
    //which any nested advance-search screen (also UiEngineComponent-based) overwrites globally.
    //type_code travels the same way - this popup's form has no type_code field of its own
    let obj = { uhId: uhId, parent_id: parent_id, chartType: this['input'], type_code: this.patient_protocol_info?.protocol_type };

    // this['input'] alone can't tell protocol apart from stimulation chart (ChemotherapyProtocolComponent reuses 'stimulation_chart') - patient_protocol is the real signal.
    if (!this.patient_protocol && (this['input'] == 'et_monitoring_chart' || this['input'] == 'stimulation_chart')) {
      if (this['input'] == 'et_monitoring_chart') {
        this.openFormDialog('medication_care_plan_protocol', 'Medication Order', 'ADD_MEDICATION', "", obj);
      } else {
        this.pacClearance(cb => {
          if (cb) {
            this.openFormDialog('medication_care_plan_protocol', 'Medication Order', 'ADD_MEDICATION', "", obj);
          }
        });
      }
    } else {
      this.pacClearance(cb => {
        if (cb) {
          this.openFormDialog('medication_care_plan_protocol', 'Medication Order', 'ADD_MEDICATION', "", obj);
        }
      })
    }
  }

  clinicalForm(loc?: any): void {
    let parent_id = this.apiData?.[0]?.parent_id || this.apiData?.[0]?.id;
    let uhId = this.patientDetails?.uhId || this.apiData?.[0]?.uhId;
    let obj = { uhId: uhId, parent_id: parent_id, chartType: this['input'] };

    // see medicationForm above - patient_protocol is the real signal, not this['input'].
    if (!this.patient_protocol && (this['input'] == 'et_monitoring_chart' || this['input'] == 'stimulation_chart')) {
      if (this['input'] == 'et_monitoring_chart') {
        this.openFormDialog('clinical_care_plan_protocol', 'Clinical Order', 'ADD_CLINICAL', "", obj);
      } else {
        this.pacClearance(cb => {
          if (cb) {
            this.openFormDialog('clinical_care_plan_protocol', 'Clinical Order', 'ADD_CLINICAL', "", obj);
          }
        });
      }
    } else {
      if (loc == 'grading') {
        this.openFormDialog('clinical_embryo_grading', 'Clinical Order', 'ADD_CLINICAL_ORDER', 'clinical_grading');
      } else {
        this.pacClearance(cb => {
          if (cb) {
            this.openFormDialog('clinical_care_plan_protocol', 'Clinical Order', 'ADD_CLINICAL');
          }
        })
      }
    }
  }


  addSurgery() {
    let obj = { parent_facility_id: this.appService.getOrganizationList()[0]?.org_id, uhId: this.patientDetails?.uhId, encounter_id: this.patientDetails?.encounter_id }
    if (this.appService.getUniversalConfig('multi_care_type')) {
      obj['care_type'] = this.appService.getDynamicFunctions("getCurrentCareType");
    }
    if (this['input'] == 'et_monitoring_chart') {
      this.openFormDialog(!this.patient_protocol ? 'surgery_care_plan_protocol_stimulation' : 'surgery_care_plan_protocol', 'Add Surgery', 'ADD_SURGERY', "", obj);
    } else {
      this.pacClearance(cb => {
        if (cb) {
          this.openFormDialog(!this.patient_protocol ? 'surgery_care_plan_protocol_stimulation' : 'surgery_care_plan_protocol', 'Add Surgery', 'ADD_SURGERY', "", obj);
        }
      })
    }
  }

  openFormDialog(resource: string, title: string, action: string, source?, data = {}): void {
    const popObj = {
      data: data,
      action: "ADD",
      getdata: true,
      layout_type: "simple",
      application: "emr",
      title,
      size: DialogModalSize.Lg,
      resource,
      customButton: {
        Add: [{ label: "button.confirm", icon: "fa fa-check" }]
      }
    };

    this.dialogService.open(PopupFormComponent, popObj).afterClosed.subscribe(response => {
      let resourceMain = (this['input'] == 'et_monitoring_chart' ? 'embryo_chart_details' : 'stimulation_chart_details');
      this.changaData(source, response, action, resourceMain, resource);
    })
  }

  changaData(source, response, action, resourceMain, resource) {
    if (source != 'clinical_grading' && response?.result?.no_of_days) {
      let payload = {}
      if (this.patient_protocol) {
        let _arr = [];
        _arr.push(response.result)
        payload = response.result.no_of_days.map(day => ({
          surgeryRequest: _arr,
          uhId: this.apiData[0].uhId,
          encounter_id: this.apiData[0].encounter_id,
          protocol_id: this.patient_protocol_info?.protocol_id,
          no_of_sittings: day.text
        }));
      } else {
        payload = response.result.no_of_days.map(day => ({
          ...response.result,
          no_of_days: day.text,
          uhId: this.apiData[0].uhId,
          encounter_id: this.apiData[0].encounter_id,
        }));
      }

      this.formService.baseService.action(payload, action, "emr", resourceMain).subscribe(
        (res: any) => {
          if (res.errCode == 0) {
            this.dataCall();
          }
        });
    } else if (source != 'clinical_grading' && response.result) {
      this.formService.baseService.action(response.result, action, "emr", resourceMain).subscribe(
        (res: any) => {
          if (res.errCode == 0) {
            this.dataCall();
          }
        });
    }
    if (source == 'clinical_grading') {
      let arr = ['serviceRequestId', 'treatingDoctor', 'treatingDoctorDepartmentName', 'treatingDoctorId', 'treatingDoctorSpeciality', 'treatingDoctorSpecialityCode', 'treatingDoctorSubDepartmentName', 'uhId', 'episode_id', 'patient_id', 'patientType']
      let d = JSON.parse(sessionStorage.getItem("currentData"));
      arr.forEach(element => {
        response.result[element] = d[element]
      });
      this.formService.baseService.action(response.result, action, "emr", resourceMain).subscribe(
        (res: any) => {
          if (res.errCode == 0) {
            this.formService.alerts.success("Request Successful");
          }
        });
    }
    // });
  }

  forLoop(start: number, callback: (i: number) => void): void {
    let pSize = this.pageSize;
    if (this.utilService.isMobile()) {
      pSize = this.totalItems
    }
    for (let i = start; i < start + pSize; i++) {
      callback(i);
    }
  }

  get currentPageEnd(): number {
    return Math.min(this.currentPageStart + this.pageSize - 1, this.totalItems);
  }

  get isPrevDisabled(): boolean {
    return this.currentPageStart === 1;
  }

  get isNextDisabled(): boolean {
    return this.currentPageEnd >= this.totalItems;
  }

  prevPage(e: number): void {
    if (!this.isPrevDisabled) {
      this.currentPageStart -= this.pageSize;
      this.updatePage(e - this.pageSize);
    }
  }

  nextPage(e: number): void {
    if (!this.isNextDisabled) {
      this.currentPageStart += this.pageSize;
      this.updatePage(e + 1);
    }
  }

  updatePage(pageStart: number): void {
    this.stimulationData(this.apiData, pageStart);
    this.initializeFields(pageStart);
    const currentInput = this['input']
    this['input'] = 'embryo_summary'
    setTimeout(() => {
      this['input'] = currentInput
    });
  }

  filterByType(data: any[], type: string): any[] {
    return data.filter(item => item.details_type === type);
  }

  capability() {
    let arr: any[] = [
      {
        "action": "popup_form",
        "label": this['input'] == 'et_monitoring_chart' ?"menu.process_order":"field.label.item_consumption",
        "query_id": "GET_BY_ID",
        "dependent_fields2BindData": "id",
        "args": "id",
        "conditions": this['input'] == 'stimulation_chart' ? [{
          "expression": "item['stage'] != 'Discontinue' "
        }] : [],
        "resource": this['input'] == 'et_monitoring_chart' ? 'embryo_chart_details' : 'stimulation_chart_details',
        "decorator": "ProtocolAdminsiterDecorator",
        "auto_refresh": false,
        "api_action": "BULK_MEDICATION_ORDER",
        "title": this['input'] == 'et_monitoring_chart' ?"Process Order":"Item Consumption",
        "permission_required": false,
        "form": this.itemConsumptionForm(true,(this['input'] == 'et_monitoring_chart'?false:true))
      },
      {
        "action": "popup_form",
        "label": "button.discontinue",
        "query_id": "GET_BY_ID",
        "dependent_fields2BindData": "id",
        "args": "id",
        "api_action": "DISCONTINUE_MEDICATION",
        "resource": (this['input'] == 'et_monitoring_chart' ? 'embryo_chart_details' : this.patient_protocol ? 'patient_assigned_protocols_details' : 'stimulation_chart_details'),
        "application": "emr",
        "auto_refresh": false,
          "conditions": this['input'] == 'stimulation_chart' ? [{
          "expression": "item['stage'] != 'Discontinue' "
        }] : [],
        "title": "Reason for Dicontinue",
        "permission_required": false,
        "form": {
          "blocks": [
            {
              "class_name": "null",
              "order": 1,
              "layout_type": "one-column",
              "fields": [
                {
                  "label": "field.label.reason",
                  "class_name": "kx-control col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 fix",
                  "order": 2,
                  "required": true,
                  "type": "string",
                  "component": "textarea",
                  "hint": "field.hint.reason",
                  "maxlength": 500,
                  "name": "reason"
                }
              ]
            }
          ]
        }
      },
      {
        "action": "popup_form",
        "query_id": "GET_BY_ID",
        "auto_refresh": false,
        "permission_required": false,
        "dependent_fields2BindData": "id",
        "args": "id",
        "application": "emr",
        "api_action": "HOLD_MEDICATION",
        "conditions": this['input'] == 'stimulation_chart' ? [{
          "expression": "item['stage'] != 'Discontinue' "
        }] : [],
        "resource": (this['input'] == 'et_monitoring_chart' ? 'embryo_chart_details' : this.patient_protocol ? 'patient_assigned_protocols_details' : 'stimulation_chart_details'),
        "title": "Reason for Hold",
        "label": "button.hold",
        "form": {
          "blocks": [
            {
              "class_name": "null",
              "order": 1,
              "layout_type": "one-column",
              "fields": [
                {
                  "label": "field.label.reason",
                  "class_name": "kx-control col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 fix",
                  "order": 2,
                  "required": true,
                  "type": "string",
                  "component": "textarea",
                  "hint": "field.hint.reason",
                  "maxlength": 500,
                  "name": "reason"
                }
              ]
            }
          ]
        }
      },
      {
        "action": "confirm",
        "label": "button.resume.medication",
        "auto_refresh": false,
        // "conditions": this.patient_protocol ? [{
        //   "expression": "item['order_sent'] == true "
        // }] : [],
        "permission_required": false,
        "conditions": this['input'] == 'stimulation_chart' ? [{
          "expression": "item['stage'] != 'Discontinue' "
        }] : [],
        "message": "Do you really want to resume this medicine ",
        "datasource": {
          "action": "RESUME_MEDICATION",
          "resource": (this.patient_protocol ? 'patient_assigned_protocols_details' : 'stimulation_chart_details'),
          "application": "emr"
        }
      },
      {
        "action": "popup_form",
        "query_id": "GET_BY_ID",
        "dependent_fields2BindData": "id",
        "args": "id",
        "application": "emr",
        "conditions": this['input'] == 'stimulation_chart' ? [{
          "expression": "item['stage'] != 'Discontinue' "
        }] : [],
        "auto_refresh": false,
        "resource": (this['input'] == 'et_monitoring_chart' ? 'embryo_chart_details' : this.patient_protocol ? 'patient_assigned_protocols_details' : 'stimulation_chart_details'),
        "api_action": "UPDATE_QOH",
        "title": "Update QOH",
        "label": "button.Update_QOH",
        "permission_required": false,
        "form": {
          "blocks": [
            {
              "name": "Update QOH",
              "class_name": "null",
              "order": 1,
              "fields": [
                {
                  "label": "field.label.qoh",
                  "class_name": "kx-control col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 fix",
                  "order": 1,
                  "type": "string",
                  "pattern": "^[0-9+]*$",
                  "required": true,
                  "component": "textbox",
                  "hint": "field.label.qoh",
                  "name": "qoh"
                }
              ],
              "title": ""
            }
          ]
        }
      },
      {
        "action": "popup_form",
        "query_id": "GET_BY_ID",
        "auto_refresh": false,
        "dependent_fields2BindData": "id",
        "args": "id",
         "conditions": this['input'] == 'stimulation_chart' ? [{
          "expression": "item['stage'] != 'Discontinue' "
        }] : [],
        "decorator": "marFrequencyChange",
        ...(!this.patient_protocol ? { append_required: false } : {}),
        "application": "emr",
        "resource": (this['input'] == 'et_monitoring_chart' ? 'embryo_chart_details' : this.patient_protocol ? 'patient_assigned_protocols_details' : 'stimulation_chart_details'),
        "check_validation": true,
        "api_action": "CHANGE_FREQUENCY_AND_DOSAGE",
        "title": "Change Frequency and Dosage(NOTE: Previous medication will be discontinued)",
        "label": "button.change_frequency",
        "permission_required": false,
        "form": {
          "blocks": [
            {
              "class_name": "null",
              "order": 1,
              "fields": this.patient_protocol ? [
                {
                  "label": "field.label.duration_in_days",
                  "order": 1,
                  "component": "hidden",
                  "name": "days",
                  "type": "number"
                },
                {
                  "label": "field.label.end_date_time",
                  "order": 1,
                  "component": "hidden",
                  "name": "endDate"
                },
                {
                  "label": "field.label.frequency",
                  "order": 1,
                  "populate_field": true,
                  "getterKey": "id",
                  "getterValue": "frequency",
                  "view_key": "frequency",
                  "class_name": "kx-control col-12 col-sm-4 col-md-4 col-lg-4 col-xl-4 fix",
                  "req_keys": "all",
                  "type": "String",
                  "component": "searchselect",
                  "stopSorting": true,
                  "required": true,
                  "dependents": [
                    {
                      "dependent_field": "frequency",
                      "value": "frequency",
                      "action": "populate_field"
                    },
                    {
                        "dependent_field": "frequencyInfo",
                        "value": "frequencyId",
                        "action": "populate_field"
                    }
                  ],
                  "datasource": {
                    "application": "emr",
                    "resource": "frequency_master",
                    "query_id": "GET_FREQUENCY",
                    "cachable": true,
                    "key": "id"
                  },
                  "defaultsetting": {
                    "singleSelection": true,
                    "closeDropDownOnSelection": true,
                    "allowSearchFilter": true,
                    "checkBoxRequired": false,
                    "apliCall": true
                  },
                  "name": "frequencyId"
                },
                {
                  "label": "field.label.dosage",
                  "order": 13,
                  "name": "dosage_no",
                  "default": "1",
                  "class_name": "kx-control col-12 col-sm-4 col-md-4 col-lg-4 col-xl-4 fix",
                  "component": "textbox",
                  "pattern": "^$|^[0-9]+(\\.[0-9]{1,2})?$",
                  "type": "string"
                },
                {
                  "name": "frequencyInfo",
                  "component": "hidden"
                },
                {
                  "label": "field.label.dosage_form",
                  "order": 13,
                  "name": "dosage_form",
                  "class_name": "kx-control col-12 col-sm-4 col-md-4 col-lg-4 col-xl-4 fix",
                  "getterKey": "display",
                  "getterValue": "display",
                  "datasource": {
                    "application": "system-management",
                    "query_id": "get_valueset_by_id_flat",
                    "args": "resourceId:dosage_form,system:karexpert",
                    "resource": "valueset"
                  },
                  "component": "dropdown"
                },
                {
                  "component": "hidden",
                  "name": "frequency"
                },
                {
                  "label": "field.label.morning",
                  "order": 3,
                  "name": "morning",
                  "default": "0",
                  "visible": false,
                  "class_name": "kx-control col-12 col-sm-2 col-md-2 col-lg-2 col-xl-2 fix",
                  "component": "textbox",
                  "pattern": "^$|^[0-9]+(\\.[0-9]{1,2})?$",
                  "type": "string"
                },
                {
                  "label": "field.label.afternoon",
                  "order": 3,
                  "name": "afternoon",
                  "default": "0",
                  "visible": false,
                  "class_name": "kx-control col-12 col-sm-2 col-md-2 col-lg-2 col-xl-2 fix",
                  "component": "textbox",
                  "pattern": "^$|^[0-9]+(\\.[0-9]{1,2})?$",
                  "type": "string"
                },
                {
                  "label": "field.label.evening",
                  "order": 3,
                  "name": "evening",
                  "default": "0",
                  "visible": false,
                  "class_name": "kx-control col-12 col-sm-2 col-md-2 col-lg-2 col-xl-2 fix",
                  "component": "textbox",
                  "pattern": "^$|^[0-9]+(\\.[0-9]{1,2})?$",
                  "type": "string"
                },
                {
                  "label": "field.label.night",
                  "order": 3,
                  "name": "night",
                  "default": "0",
                  "visible": false,
                  "class_name": "kx-control col-4 col-sm-2 col-md-2 col-lg-2 col-xl-2 fix",
                  "component": "textbox",
                  "pattern": "^$|^[0-9]+(\\.[0-9]{1,2})?$",
                  "type": "string"
                },
                {
                  "label": "field.label.quantity",
                  "order": 5,
                  "name": "quantity",
                  "class_name": "kx-control col-4 col-sm-2 col-md-2 col-lg-2 col-xl-2 fix",
                  "component": "numberbox",
                  "type": "number"
                },
                {
                  "component": "hidden",
                  "name": "from_protocol",
                  "value": "protocol"
                }
              ] : [
                {
                  "label": "field.label.duration_in_days",
                  "order": 1,
                  "component": "hidden",
                  "name": "days",
                  "type": "number"
                },
                {
                  "label": "field.label.end_date_time",
                  "order": 1,
                  "component": "hidden",
                  "name": "endDate"
                },
                {
                  "name": "frequencyInfo",
                  "component": "hidden"
                },
                {
                  "label": "field.label.frequency",
                  "order": 1,
                  "populate_field": true,
                  "getterKey": "id",
                  "getterValue": "frequency",
                  "view_key": "frequency",
                  "class_name": "kx-control col-12 col-sm-4 col-md-4 col-lg-4 col-xl-4 fix",
                  "req_keys": "all",
                  "type": "String",
                  "component": "searchselect",
                  "stopSorting": true,
                  "required": true,
                  "dependents": [
                    {
                      "dependent_field": "frequency",
                      "value": "frequency",
                      "action": "populate_field"
                    },
                    {
                        "dependent_field": "frequencyInfo",
                        "value": "frequencyId",
                        "action": "populate_field"
                    }
                  ],
                  "datasource": {
                    "application": "emr",
                    "resource": "frequency_master",
                    "query_id": "GET_FREQUENCY",
                    "cachable": true,
                    "key": "id"
                  },
                  "defaultsetting": {
                    "singleSelection": true,
                    "closeDropDownOnSelection": true,
                    "allowSearchFilter": true,
                    "checkBoxRequired": false,
                    "apliCall": true
                  },
                  "name": "frequencyId"
                },
                {
                  "label": "field.label.dosage",
                  "order": 13,
                  "name": "dosage_no",
                  "default": "1",
                  "class_name": "kx-control col-12 col-sm-4 col-md-4 col-lg-4 col-xl-4 fix",
                  "component": "textbox",
                  "pattern": "^$|^[0-9]+(\\.[0-9]{1,2})?$",
                  "type": "string"
                },
                {
                  "label": "field.label.dosage_form",
                  "order": 13,
                  "name": "dosage_form",
                  "class_name": "kx-control col-12 col-sm-4 col-md-4 col-lg-4 col-xl-4 fix",
                  "getterKey": "display",
                  "getterValue": "display",
                  "datasource": {
                    "application": "system-management",
                    "query_id": "get_valueset_by_id_flat",
                    "args": "resourceId:dosage_form,system:karexpert",
                    "resource": "valueset"
                  },
                  "component": "dropdown"
                },
                {
                  "component": "hidden",
                  "name": "frequency"
                },
                {
                  "label": "field.label.morning",
                  "order": 3,
                  "name": "morning",
                  "default": "0",
                  "visible": false,
                  "class_name": "kx-control col-12 col-sm-2 col-md-2 col-lg-2 col-xl-2 fix",
                  "component": "textbox",
                  "pattern": "^$|^[0-9]+(\\.[0-9]{1,2})?$",
                  "type": "string"
                },
                {
                  "label": "field.label.afternoon",
                  "order": 3,
                  "name": "afternoon",
                  "default": "0",
                  "visible": false,
                  "class_name": "kx-control col-12 col-sm-2 col-md-2 col-lg-2 col-xl-2 fix",
                  "component": "textbox",
                  "pattern": "^$|^[0-9]+(\\.[0-9]{1,2})?$",
                  "type": "string"
                },
                {
                  "label": "field.label.evening",
                  "order": 3,
                  "name": "evening",
                  "default": "0",
                  "visible": false,
                  "class_name": "kx-control col-12 col-sm-2 col-md-2 col-lg-2 col-xl-2 fix",
                  "component": "textbox",
                  "pattern": "^$|^[0-9]+(\\.[0-9]{1,2})?$",
                  "type": "string"
                },
                {
                  "label": "field.label.night",
                  "order": 3,
                  "name": "night",
                  "default": "0",
                  "visible": false,
                  "class_name": "kx-control col-4 col-sm-2 col-md-2 col-lg-2 col-xl-2 fix",
                  "component": "textbox",
                  "pattern": "^$|^[0-9]+(\\.[0-9]{1,2})?$",
                  "type": "string"
                },
                {
                  "label": "field.label.quantity",
                  "order": 5,
                  "name": "quantity",
                  "class_name": "kx-control col-4 col-sm-2 col-md-2 col-lg-2 col-xl-2 fix",
                  "component": "numberbox",
                  "type": "number"
                },
                {
                  "component": "hidden",
                  "name": "from_protocol",
                  "value": "protocol"
                }
              ],
              "title": ""
            }
          ]
        }
      }
    ]
    if (this.patient_protocol) {
      let infusionChangeRate = {
        "action": "popup_form",
        "query_id": "GET_BY_ID",
        "dependent_fields2BindData": "id",
        "args": "id",
        "application": "emr",
        "conditions": [{
          "expression": "item['infusion_order'] == true "
        }],
        "auto_refresh": false,
        "resource": 'patient_assigned_protocols_details',
        "api_action": "UPDATE_INFUSION_RATE",
        "title": "Change Infusion Rate",
        "label": "field.label.change_infusion_rate",
        "permission_required": false,
        "form": {
          "blocks": [
            {
              "name": "Change Infusion Rate",
              "class_name": "null",
              "order": 1,
              "fields": [
                {
                  "label": "field.label.infusion_rate",
                  "class_name": "kx-control col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 fix",
                  "order": 1,
                  "type": "string",
                  "pattern": "^[0-9+]*$",
                  "required": true,
                  "component": "textbox",
                  "hint": "field.label.change_infusion_rate",
                  "name": "infusion_rate"
                },
                {
                  "label": "field.label.infusion_unit",
                  "class_name": "kx-control col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 fix",
                  "order": 2,
                  "type": "string",
                  "disabled": true,
                  "component": "textbox",
                  "default": "ml/h",
                  "name": "infusion_unit"
                }
              ],
              "title": ""
            }
          ]
        }
      }
      arr.push(infusionChangeRate)

    }
    return arr
  }

  clinicalCapability() {
    let arr = [];
    return arr;
  }

  checkPermission(data) {
    const permissionList = [];
    for (const capability of data) {
      const actionName = capability.action_name;
      const resource = 'stimulation_chart';
      const application = capability.application || capability.datasource?.application || '';
      const hasPermission = this.rolePermissionService.checkAccessPermission(actionName, resource, application);
      if (hasPermission) {
        permissionList.push(capability);
      }
    }
    return permissionList;
  }


  getCapability() {
    let conditionObj = {}
    if(this.gridData['item_consumption_capability'] && this['input'] != 'et_monitoring_chart'){
      conditionObj['missedAministerConditions'] = "((item['status']=='Missed') && (item['stage'] == 'Pending' || item['stage'] == 'Request Sent' || item['stage'] == 'Consumption Done') && item['isAdministered'] == false)"
      conditionObj['itemConsumptionConditions'] = "((item['status']=='Missed'|| item['status']=='Pending') && item['stage'] == 'Pending' && item['isAdministered'] == false && item['isConsumed'] == false)"
      conditionObj['administerConditions'] = "((item['status']=='Pending') && (item['stage'] == 'Pending' || item['stage'] == 'Request Sent' || item['stage'] == 'Consumption Done') && item['isAdministered'] == false && item['greaterThanCurrentDate'] != true)"
    }
    let arr: any[] = [

      {
        "action": "popup_form",
        "query_id": "GET_BY_ID",
        "dependent_fields2BindData": "id",
        "args": "id",
        "application": "emr",
        "auto_refresh": false,
        "resource": (this['input'] == 'et_monitoring_chart' ? 'embryo_chart_details' : this.patient_protocol ? 'patient_assigned_protocols_details' : 'stimulation_chart_details'),
        "title": "Missed Administer",
        "label": "button.missed_administer",
        "api_action": (this.patient_protocol ? "ADMINISTER_MEDICINE" : "ADMINISTER"),
        "conditions": this.patient_protocol ? [{"expression": "item['status'] == 'Missed' && item['qoh'] != 0 && item['greaterThanCurrentDate'] != true && item['order_sent'] == true"}] : [
          {
            "expression": conditionObj['missedAministerConditions']? conditionObj['missedAministerConditions']:("item['status'] == 'Missed' && item['qoh'] != 0 && item['greaterThanCurrentDate'] != true")
          }
        ],
        "form": {
          "blocks": [
            {
              "name": "Patient Administer Block",
              "class_name": "null",
              "order": 1,
              "layout_type": "no-column",
              "fields": [
                {
                  "label": "",
                  "class_name": "kx-control col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 fix",
                  "order": 1,
                  "type": "String",
                  "visible": true,
                  "required": true,
                  "default": "Administered By Nurse",
                  "component": "radio",
                  "dependents": [
                    {
                      "dependent_field": "rightPatient",
                      "value": "Administered Externally (By Patient)",
                      "action": "invisible"
                    },
                    {
                      "dependent_field": "rightMedication",
                      "value": "Administered Externally (By Patient)",
                      "action": "invisible"
                    },
                    {
                      "dependent_field": "rightDose",
                      "value": "Administered Externally (By Patient)",
                      "action": "invisible"
                    },
                    {
                      "dependent_field": "rightRoute",
                      "value": "Administered Externally (By Patient)",
                      "action": "invisible"
                    }, {
                      "dependent_field": "rightTIme",
                      "value": "Administered Externally (By Patient)",
                      "action": "invisible"
                    },
                    {
                      "dependent_field": "rightMedication",
                      "value": "Administered Externally (By Patient)",
                      "action": "invisible"
                    },
                    {
                      "dependent_field": "batchNo",
                      "value": "Administered Externally (By Patient)",
                      "action": "invisible"
                    },
                    {
                      "dependent_field": "time",
                      "value": "Administered Externally (By Patient)",
                      "action": "invisible"
                    },
                    {
                      "dependent_field": "description",
                      "value": "Administered Externally (By Patient)",
                      "action": "invisible"
                    },
                    {
                      "dependent_field": "batchNoScan",
                      "value": "Administered Externally (By Patient)",
                      "action": "invisible"
                    }, {
                      "dependent_field": "medicineIssued",
                      "value": "Administered Externally (By Patient)",
                      "action": "invisible"
                    },
                    {
                      "dependent_field": "virification",
                      "value": "Administered Externally (By Patient)",
                      "action": "invisible"
                    },
                    {
                      "dependent_field": "startTime",
                      "value": "Administered Externally (By Patient)",
                      "action": "invisible"
                    },
                    {
                      "dependent_field": "endTime",
                      "value": "Administered Externally (By Patient)",
                      "action": "invisible"
                    },
                    {
                      "dependent_field": "comment",
                      "value": "Administered Externally (By Patient)",
                      "action": "invisible"
                    },
                    {
                      "dependent_field": "witnessedBy",
                      "value": "Administered Externally (By Patient)",
                      "action": "invisible"
                    },
                    {
                      "dependent_field": "remark",
                      "value": "Administered Externally (By Patient)",
                      "action": "invisible"
                    },
                    {
                      "dependent_field": "is_multidose",
                      "value": "Administered Externally (By Patient)",
                      "action": "invisible"
                    },
                    {
                      "dependent_field": "rightTime",
                      "value": "Administered Externally (By Patient)",
                      "action": "invisible"
                    },
                    {
                      "dependent_field": "administer_time",
                      "value": "Administered Externally (By Patient)",
                      "action": "visible"
                    },
                    {
                      "dependent_field": "route",
                      "value": "Administered Externally (By Patient)",
                      "action": "visible"
                    },
                    {
                      "dependent_field": "administer_dose",
                      "value": "Administered Externally (By Patient)",
                      "action": "visible"
                    },
                    {
                      "dependent_field": "administer_time",
                      "value": "Administered Externally (By Patient)",
                      "action": "visible"
                    }

                  ],
                  "datasource": {
                    "possible_value": [
                      {
                        "id": "Administered By Nurse",
                        "value": "Administered By Nurse"
                      },
                      {
                        "id": "Administered Externally (By Patient)",
                        "value": "Administered Externally (By Patient)"
                      }
                    ]
                  },
                  "name": "administer_type"
                }
              ]
            },

            {
              "name": "basic_information",
              "class_name": "null",
              "order": 3,
              "layout_type": "no-column",
              "fields": [
                {
                  "label": "field.label.reason_of_missed",
                  "class_name": "kx-control col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 fix",
                  "order": 1,
                  "type": "String",
                  "required": true,
                  "component": "textarea",
                  "maxlength": 500,
                  "hint": "field.hint.reason",
                  "name": "reason"
                }
              ],
              "title": ""
            },
            {
              "name": "Mar Verification Block",
              "class_name": "null",
              "order": 1,
              "layout_type": "two-column",
              "fields": [
                {
                  "order": 1,
                  "type": "String",
                  "component": "hidden",
                  "name": "marMedicationId",
                  "condition": [
                    {
                      "application": "emr",
                      "getterKey": "id"
                    }
                  ]
                },
                {
                  "dependents": [
                    {
                      "dependent_field": "rightPatient",
                      "value": "manual",
                      "action": "validate",
                      "validations": {
                        "required": true
                      }
                    },
                    {
                      "dependent_field": "rightMedication",
                      "value": "manual",
                      "action": "validate",
                      "validations": {
                        "required": true
                      }
                    },
                    {
                      "dependent_field": "rightDose",
                      "value": "manual",
                      "action": "validate",
                      "validations": {
                        "required": true
                      }
                    },
                    {
                      "dependent_field": "rightRoute",
                      "value": "manual",
                      "action": "validate",
                      "validations": {
                        "required": true
                      }
                    },
                    {
                      "dependent_field": "rightTime",
                      "value": "manual",
                      "action": "validate",
                      "validations": {
                        "required": true
                      }
                    },
                    {
                      "dependent_field": "rightPatient",
                      "value": "manual",
                      "action": "visible"
                    },
                    {
                      "dependent_field": "rightMedication",
                      "value": "manual",
                      "action": "visible"
                    },
                    {
                      "dependent_field": "rightDose",
                      "value": "manual",
                      "action": "visible"
                    },
                    {
                      "dependent_field": "rightRoute",
                      "value": "manual",
                      "action": "visible"
                    },
                    {
                      "dependent_field": "rightTime",
                      "value": "manual",
                      "action": "visible"
                    },
                    {
                      "dependent_field": "time",
                      "value": "medication",
                      "action": "visible"
                    },
                    {
                      "dependent_field": "batchNo",
                      "value": "medication",
                      "action": "visible"
                    },
                    {
                      "dependent_field": "description",
                      "value": "medication",
                      "action": "visible"
                    },
                    {
                      "dependent_field": "batchNoScan",
                      "value": "medication",
                      "action": "visible"
                    },
                    {
                      "dependent_field": "medicineIssued",
                      "value": "medication",
                      "action": "visible"
                    }
                  ],
                  "label": "field.label.verification",
                  "class_name": "kx-control col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 fix",
                  "order": 1,
                  "type": "String",
                  "visible": true,
                  "required": true,
                  "component": "radio",
                  "default": "manual",
                  "datasource": {
                    "possible_value": [
                      {
                        "id": "medication",
                        "value": "Auto Verify Medication"
                      },
                      {
                        "id": "manual",
                        "value": "Manual Verification"
                      }
                    ]
                  },
                  "name": "virification"
                },
                {
                  "label": "field.label.recommended_date_time",
                  "class_name": "kx-control col-sm-4 col-lg-4 col-xl-4 col-md-4 col-12 fix",
                  "order": 2,
                  "visible": false,
                  "type": "date",
                  "component": "daterangepicker",
                  "singleDatePicker": true,
                  "locale": {
                    "format": "DD/MM/YYYY HH:mm"
                  },
                  "minDateNumber": 1,
                  "minDateUnit": "days",
                  "timePicker": true,
                  "timePickerSeconds": true,
                  "timePicker24Hour": true,
                  "timePickerIncrement": true,
                  "autoApply": true,
                  "disabled": true,
                  "name": "time"
                }
              ],
              "title": ""
            },
            {
              "name": "Patient Administer Form Block",
              "class_name": "null",
              "order": 1,
              "layout_type": "three-column",
              "fields": [
                {
                  "label": "field.label.qty/dosage",
                  "class_name": "kx-control col-sm-4 col-lg-4 col-xl-4 col-md-4 col-12 fix",
                  "order": 1,
                  "name": "administer_dose",
                  "component": "numberbox",
                  "type": "number",
                  "visible": false,
                  "default": 1
                },
                {
                  "label": "field.label.route",
                  "class_name": "kx-control col-sm-4 col-lg-4 col-xl-4 col-md-4 col-12 fix",
                  "order": 1,
                  "visible": false,
                  "type": "String",
                  "component": "textbox",
                  "name": "route"
                },
                {
                  "label": "field.label.administer_time",
                  "class_name": "kx-control col-12 col-sm-6 col-md-4 col-lg-4 col-xl-4 fix",
                  "order": 1,
                  "type": "Long",
                  "locale": {
                    "format": "DD/MM/YYYY HH:mm"
                  },
                  "component": "daterangepicker",
                  "singleDatePicker": true,
                  "maxDateUnit": "days",
                  "maxDateNumber": 0,
                  "timePicker": true,
                  "timePickerSeconds": false,
                  "autoapply": true,
                  "selected": true,
                  "timePicker24Hour": false,
                  "name": "administer_time"
                }
              ]
            },
            {
              "name": "other_block",
              "class_name": "null",
              "order": 1,
              "layout_type": "three-column",
              "fields": [
                {
                  "label": "field.label.issued_batch_no",
                  "class_name": "kx-control col-sm-4 col-lg-4 col-xl-4 col-md-4 col-12 fix",
                  "order": 3,
                  "visible": false,
                  "type": "string",
                  "component": "textbox",
                  "name": "batchNo",
                  "disabled": true
                },
                {
                  "label": "field.label.doctor_instruction",
                  "class_name": "kx-control col-sm-4 col-lg-4 col-xl-4 col-md-4 col-12 fix",
                  "order": 4,
                  "visible": false,
                  "type": "string",
                  "component": "textbox",
                  "name": "description",
                  "disabled": true
                },
                {
                  "label": "field.label.issued_medicine",
                  "class_name": "kx-control col-sm-4 col-lg-4 col-xl-4 col-md-4 col-12 fix",
                  "order": 5,
                  "visible": false,
                  "type": "string",
                  "component": "textbox",
                  "name": "medicineIssued",
                  "disabled": true
                },
                {
                  "label": "field.label.batch_no",
                  "class_name": "kx-control col-sm-4 col-lg-4 col-xl-4 col-md-4 col-12 fix",
                  "order": 6,
                  "visible": false,
                  "type": "string",
                  "component": "textbox",
                  "name": "batchNoScan"
                },
                {
                  "label": "field.label.right_patient",
                  "class_name": "kx-control col-sm-4 col-lg-4 col-xl-4 col-md-4 col-12 fix",
                  "order": 7,
                  "default": true,
                  "required": true,
                  "visible": false,
                  "type": "Boolean",
                  "component": "checkbox",
                  "name": "rightPatient"
                },
                {
                  "label": "field.label.right_medication",
                  "class_name": "kx-control col-sm-4 col-lg-4 col-xl-4 col-md-4 col-12 fix",
                  "order": 8,
                  "required": true,
                  "default": true,
                  "visible": false,
                  "type": "Boolean",
                  "component": "checkbox",
                  "name": "rightMedication"
                },
                {
                  "label": "field.label.right_dose",
                  "class_name": "kx-control col-sm-4 col-lg-4 col-xl-4 col-md-4 col-12 fix",
                  "order": 9,
                  "default": true,
                  "required": true,
                  "visible": false,
                  "type": "Boolean",
                  "component": "checkbox",
                  "name": "rightDose"
                },
                {
                  "label": "field.label.right_route",
                  "class_name": "kx-control col-sm-4 col-lg-4 col-xl-4 col-md-4 col-12 fix",
                  "order": 10,
                  "required": true,
                  "default": true,
                  "visible": false,
                  "type": "Boolean",
                  "component": "checkbox",
                  "name": "rightRoute"
                },
                {
                  "label": "field.label.right_time",
                  "class_name": "kx-control col-sm-4 col-lg-4 col-xl-4 col-md-4 col-12 fix",
                  "order": 11,
                  "default": true,
                  "required": true,
                  "visible": false,
                  "type": "Boolean",
                  "component": "checkbox",
                  "name": "rightTime"
                }
              ],
              "title": ""
            },
            {
              "class_name": "null",
              "order": 2,
              "layout_type": "two-column",
              "fields": [
                {
                  "label": "field.label._start_time",
                  "class_name": "kx-control col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6 fix",
                  "order": 1,
                  "type": "date",
                  "selected": true,
                  "component": "timepicker",
                  "locale": {
                    "format": "HH:mm:ss"
                  },
                  "visible": false,
                  "timePicker": true,
                  "timePickerSeconds": false,
                  "timePicker24Hour": false,
                  "timePickerIncrement": 1,
                  "name": "startTime"
                },
                {
                  "label": "field.label.end_time",
                  "class_name": "kx-control col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6 fix",
                  "order": 2,
                  "type": "date",
                  "selected": true,
                  "visible": false,
                  "component": "timepicker",
                  "locale": {
                    "format": "HH:mm:ss"
                  },
                  "timePicker": true,
                  "timePickerSeconds": false,
                  "timePicker24Hour": false,
                  "timePickerIncrement": 1,
                  "name": "endTime"
                },
                {
                  "order": 1,
                  "type": "String",
                  "component": "hidden",
                  "name": "itemCode"
                },
                {
                  "label": "field.label.witnessed_by",
                  "class_name": "kx-control col-sm-6 col-lg-6 col-xl-6 col-md-6 col-12 fix",
                  "order": 3,
                  "type": "String",
                  "component": "textbox",
                  "name": "witnessedBy"
                },
                {
                  "label": "field.label.comment",
                  "class_name": "kx-control col-sm-6 col-lg-6 col-xl-6 col-md-6 col-12 fix",
                  "order": 4,
                  "type": "String",
                  "component": "textbox",
                  "name": "comment"
                }
              ]
            },
            {
              "class_name": "null",
              "order": 3,
              "layout_type": "two-column",
              "fields": [
                {
                  "component": "hidden",
                  "name": "defaultQuantity"
                },
                {
                  "label": "field.label.is_multidose",
                  "class_name": "kx-control col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 fix",
                  "order": 20,
                  "type": "Boolean",
                  "component": "checkbox",
                  "name": "is_multidose"
                }
              ]
            }
          ]
        }
      },
      {
        "action": "popup_form",
        "label": "button.undo_given",
        "title": "Do you want to undo the given medicine?",
        "dependent_fields2BindData": "id",
        "args": "id",
        "auto_refresh": false,
        "resource": (this['input'] == 'et_monitoring_chart' ? 'embryo_chart_details' : this.patient_protocol ? "patient_assigned_protocols_details" : 'stimulation_chart_details'),
        "application": "emr",
        "api_action": "UNDO_GIVEN",
        "successMessage": "Medicine Undo Successfully",
        "type": "mar_administration",
        "conditions": this.patient_protocol ? [{
          "expression": "item['status'] == 'Given'  && item['greaterThanCurrentDate'] != true && item['order_sent'] == true"
        }] : [
          {
            "expression": "item['status'] == 'Given' && item['greaterThanCurrentDate'] != true"
          }
        ],
        "form": {
          "blocks": [
            {
              "name": "basic_information",
              "class_name": "null",
              "order": 1,
              "layout_type": "one-column",
              "fields": [
                {
                  "label": "field.label.reason",
                  "class_name": "kx-control col-lg-12 col-md-12 col-sm-12 col-xl-12 mb-12 fix image-upload",
                  "order": 1,
                  "type": "String",
                  "required": false,
                  "minlength": 2,
                  "pattern": "[^ ](.*|\n|\r|\r\n)*",
                  "component": "textarea",
                  "name": "remarks"
                }
              ],
              "title": ""
            }
          ]
        }
      },
    ];
    if(this['input'] != 'et_monitoring_chart'){
      let administerObj =     {
        "action": "popup_form",
        "query_id": "GET_BY_ID",
        "auto_refresh": false,
        "decorator": this.patient_protocol ? "ProtocolAdminsiterDecorator" : undefined,
        "dependent_fields2BindData": "id",
        "args": "id",
        "application": "emr",
        "resource": (this['input'] == 'et_monitoring_chart' ? 'embryo_chart_details' : this.patient_protocol ? 'patient_assigned_protocols_details' : 'stimulation_chart_details'),
        "conditions": this.patient_protocol ? [{
          "expression": "item['status'] == 'Pending' && item['stage'] == 'Pending'&& item['greaterThanCurrentDate'] != true && item['order_sent'] == true"
        }] : [
          {
            "expression": conditionObj['administerConditions']?conditionObj['administerConditions']:("item['status'] == 'Pending' && item['stage'] == 'Pending' && item['greaterThanCurrentDate'] != true")
          }
        ],
        "title": "MAR Administer",
        "label": "button.administer",
        "api_action": (this.patient_protocol ? "ADMINISTER_MEDICINE" : "ADMINISTER"),
        "form": {
          "blocks": [
            {
              "name": "Patient Administer Block",
              "class_name": "null",
              "order": 1,
              "layout_type": "no-column",
              "fields": [
                {
                  "label": "",
                  "class_name": "kx-control col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 fix",
                  "order": 1,
                  "type": "String",
                  "visible": true,
                  "required": true,
                  "default": "Administered By Nurse",
                  "component": "radio",
                  "dependents": [
                    {
                      "dependent_field": "rightPatient",
                      "value": "Administered Externally (By Patient)",
                      "action": "invisible"
                    },
                    {
                      "dependent_field": "rightMedication",
                      "value": "Administered Externally (By Patient)",
                      "action": "invisible"
                    },
                    {
                      "dependent_field": "rightDose",
                      "value": "Administered Externally (By Patient)",
                      "action": "invisible"
                    },
                    {
                      "dependent_field": "rightRoute",
                      "value": "Administered Externally (By Patient)",
                      "action": "invisible"
                    }, {
                      "dependent_field": "rightTIme",
                      "value": "Administered Externally (By Patient)",
                      "action": "invisible"
                    },
                    {
                      "dependent_field": "rightMedication",
                      "value": "Administered Externally (By Patient)",
                      "action": "invisible"
                    },
                    {
                      "dependent_field": "batchNo",
                      "value": "Administered Externally (By Patient)",
                      "action": "invisible"
                    },
                    {
                      "dependent_field": "time",
                      "value": "Administered Externally (By Patient)",
                      "action": "invisible"
                    },
                    {
                      "dependent_field": "description",
                      "value": "Administered Externally (By Patient)",
                      "action": "invisible"
                    },
                    {
                      "dependent_field": "batchNoScan",
                      "value": "Administered Externally (By Patient)",
                      "action": "invisible"
                    }, {
                      "dependent_field": "medicineIssued",
                      "value": "Administered Externally (By Patient)",
                      "action": "invisible"
                    },
                    {
                      "dependent_field": "virification",
                      "value": "Administered Externally (By Patient)",
                      "action": "invisible"
                    },
                    {
                      "dependent_field": "startTime",
                      "value": "Administered Externally (By Patient)",
                      "action": "invisible"
                    },
                    {
                      "dependent_field": "endTime",
                      "value": "Administered Externally (By Patient)",
                      "action": "invisible"
                    },
                    {
                      "dependent_field": "comment",
                      "value": "Administered Externally (By Patient)",
                      "action": "invisible"
                    },
                    {
                      "dependent_field": "witnessedBy",
                      "value": "Administered Externally (By Patient)",
                      "action": "invisible"
                    },
                    {
                      "dependent_field": "remark",
                      "value": "Administered Externally (By Patient)",
                      "action": "invisible"
                    },
                    {
                      "dependent_field": "is_multidose",
                      "value": "Administered Externally (By Patient)",
                      "action": "invisible"
                    },
                    {
                      "dependent_field": "rightTime",
                      "value": "Administered Externally (By Patient)",
                      "action": "invisible"
                    },
                    {
                      "dependent_field": "administer_time",
                      "value": "Administered Externally (By Patient)",
                      "action": "visible"
                    },
                    {
                      "dependent_field": "route",
                      "value": "Administered Externally (By Patient)",
                      "action": "visible"
                    },
                    {
                      "dependent_field": "administer_dose",
                      "value": "Administered Externally (By Patient)",
                      "action": "visible"
                    },
                    {
                      "dependent_field": "administer_time",
                      "value": "Administered Externally (By Patient)",
                      "action": "visible"
                    }

                  ],
                  "datasource": {
                    "possible_value": [
                      {
                        "id": "Administered By Nurse",
                        "value": "Administered By Nurse"
                      },
                      {
                        "id": "Administered Externally (By Patient)",
                        "value": "Administered Externally (By Patient)"
                      }
                    ]
                  },
                  "name": "administer_type"
                }
              ]
            },
            {
              "name": "medication_name",
              "class_name": "null",
              "order": 1,
              "layout_type": "one-column",
              "fields": [
                {
                  "label": "field.label.item_name",
                  "order": 1,
                  "type": "String",
                  "disabled": true,
                  "component": this.patient_protocol ? "textarea" : "textbox",
                  "name": "medication_name"
                },
                {
                  "type": "String",
                  "component": "hidden",
                  "name": "uhId"
                },
                {
                  "type": "String",
                  "component": "hidden",
                  "name": "date"
                },
                {
                  "type": "String",
                  "component": "hidden",
                  "name": "time"
                },

                {
                  "type": "boolean",
                  "component": "hidden",
                  "name": "infusion_order"
                },
                {
                  "type": "String",
                  "component": "hidden",
                  "name": "encounter_id"
                },
                {
                  "type": "String",
                  "component": "hidden",
                  "name": "infusion_series"
                }
              ],
              "title": ""
            },
            {
              "name": "Patient Administer Form Block",
              "class_name": "null",
              "order": 1,
              "layout_type": "three-column",
              "fields": [
                {
                  "label": "field.label.qty/dosage",
                  "class_name": "kx-control col-sm-4 col-lg-4 col-xl-4 col-md-4 col-12 fix",
                  "order": 1,
                  "name": "administer_dose",
                  "component": "numberbox",
                  "type": "number",
                  "visible": false,
                  "default": 1
                },
                {
                  "label": "field.label.route",
                  "class_name": "kx-control col-sm-4 col-lg-4 col-xl-4 col-md-4 col-12 fix",
                  "order": 1,
                  "visible": false,
                  "type": "String",
                  "component": "textbox",
                  "name": "route"
                },
                {
                  "label": "field.label.administer_time",
                  "class_name": "kx-control col-12 col-sm-6 col-md-4 col-lg-4 col-xl-4 fix",
                  "order": 1,
                  "type": "Long",
                  "locale": {
                    "format": "DD/MM/YYYY HH:mm"
                  },
                  "component": "daterangepicker",
                  "singleDatePicker": true,
                  "maxDateUnit": "days",
                  "maxDateNumber": 0,
                  "timePicker": true,
                  "timePickerSeconds": false,
                  "autoapply": true,
                  "selected": true,
                  "timePicker24Hour": false,
                  "name": "administer_time"
                }
              ]
            },
            {
              "name": "Mar Verification Block",
              "class_name": "null",
              "order": 1,
              "layout_type": "three-column",
              "fields": [
                {
                  "order": 1,
                  "type": "String",
                  "component": "hidden",
                  "name": "marMedicationId",
                  "condition": [
                    {
                      "application": "emr",
                      "getterKey": "id"
                    }
                  ]
                },
                {
                  "order": 1,
                  "type": "String",
                  "component": "hidden",
                  "name": "date"
                },
                {
                  "dependents": [
                    {
                      "dependent_field": "rightPatient",
                      "value": "manual",
                      "action": "validate",
                      "validations": {
                        "required": true
                      }
                    },
                    {
                      "dependent_field": "rightMedication",
                      "value": "manual",
                      "action": "validate",
                      "validations": {
                        "required": true
                      }
                    },
                    {
                      "dependent_field": "rightDose",
                      "value": "manual",
                      "action": "validate",
                      "validations": {
                        "required": true
                      }
                    },
                    {
                      "dependent_field": "rightRoute",
                      "value": "manual",
                      "action": "validate",
                      "validations": {
                        "required": true
                      }
                    },
                    {
                      "dependent_field": "rightTime",
                      "value": "manual",
                      "action": "validate",
                      "validations": {
                        "required": true
                      }
                    },
                    {
                      "dependent_field": "rightPatient",
                      "value": "manual",
                      "action": "visible"
                    },
                    {
                      "dependent_field": "rightMedication",
                      "value": "manual",
                      "action": "visible"
                    },
                    {
                      "dependent_field": "rightDose",
                      "value": "manual",
                      "action": "visible"
                    },
                    {
                      "dependent_field": "rightRoute",
                      "value": "manual",
                      "action": "visible"
                    },
                    {
                      "dependent_field": "rightTime",
                      "value": "manual",
                      "action": "visible"
                    },
                    {
                      "dependent_field": "time",
                      "value": "medication",
                      "action": "visible"
                    },
                    {
                      "dependent_field": "batchNo",
                      "value": "medication",
                      "action": "visible"
                    },
                    {
                      "dependent_field": "description",
                      "value": "medication",
                      "action": "visible"
                    },
                    {
                      "dependent_field": "batchNoScan",
                      "value": "medication",
                      "action": "visible"
                    },
                    {
                      "dependent_field": "medicineIssued",
                      "value": "medication",
                      "action": "visible"
                    }
                  ],
                  "label": "field.label.verification",
                  "class_name": "kx-control col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 fix",
                  "order": 1,
                  "type": "String",
                  "visible": true,
                  "required": true,
                  "default": "manual",
                  "component": "radio",
                  "datasource": {
                    "possible_value": [
                      {
                        "id": "medication",
                        "value": "Auto Verify Medication"
                      },
                      {
                        "id": "manual",
                        "value": "Manual Verification"
                      }
                    ]
                  },
                  "name": "virification"
                },
                {
                  "label": "field.label.recommended_date_time",
                  "class_name": "kx-control col-sm-4 col-lg-4 col-xl-4 col-md-4 col-12 fix",
                  "order": 2,
                  "visible": false,
                  "type": "datetime",
                  "component": "label",
                  "singleDatePicker": true,
                  "locale": {
                    "format": "DD/MM/YYYY HH:mm"
                  },
                  "minDateNumber": 1,
                  "minDateUnit": "days",
                  "timePicker": true,
                  "timePickerSeconds": true,
                  "timePicker24Hour": true,
                  "timePickerIncrement": true,
                  "autoApply": true,
                  "disabled": true,
                  "name": "time"
                }
              ],
              "title": ""
            },
            {
              "name": "other_block",
              "class_name": "null",
              "order": 1,
              "layout_type": "three-column",
              "fields": [
                {
                  "label": "field.label.issued_batch_no",
                  "class_name": "kx-control col-sm-4 col-lg-4 col-xl-4 col-md-4 col-12 fix",
                  "order": 3,
                  "visible": false,
                  "type": "string",
                  "component": "textbox",
                  "name": "batchNo",
                  "disabled": true
                },
                {
                  "label": "field.label.doctor_instruction",
                  "class_name": "kx-control col-sm-4 col-lg-4 col-xl-4 col-md-4 col-12 fix",
                  "order": 4,
                  "visible": false,
                  "type": "string",
                  "component": "textbox",
                  "name": "description",
                  "disabled": true
                },
                {
                  "label": "field.label.issued_medicine",
                  "class_name": "kx-control col-sm-4 col-lg-4 col-xl-4 col-md-4 col-12 fix",
                  "order": 5,
                  "visible": false,
                  "type": "string",
                  "component": "textbox",
                  "name": "medicineIssued",
                  "disabled": true
                },
                {
                  "label": "field.label.batch_no",
                  "class_name": "kx-control col-sm-4 col-lg-4 col-xl-4 col-md-4 col-12 fix",
                  "order": 6,
                  "visible": false,
                  "type": "string",
                  "component": "textbox",
                  "name": "batchNoScan"
                },
                {
                  "label": "field.label.right_patient",
                  "class_name": "kx-control col-sm-4 col-lg-4 col-xl-4 col-md-4 col-12 fix",
                  "order": 7,
                  "required": true,
                  "visible": false,
                  "default": true,
                  "type": "Boolean",
                  "component": "checkbox",
                  "name": "rightPatient"
                },
                {
                  "label": "field.label.right_medication",
                  "class_name": "kx-control col-sm-4 col-lg-4 col-xl-4 col-md-4 col-12 fix",
                  "order": 8,
                  "required": true,
                  "visible": false,
                  "default": true,
                  "type": "Boolean",
                  "component": "checkbox",
                  "name": "rightMedication"
                },
                {
                  "label": "field.label.right_dose",
                  "class_name": "kx-control col-sm-4 col-lg-4 col-xl-4 col-md-4 col-12 fix",
                  "order": 9,
                  "required": true,
                  "visible": false,
                  "default": true,
                  "type": "Boolean",
                  "component": "checkbox",
                  "name": "rightDose"
                },
                {
                  "label": "field.label.right_route",
                  "class_name": "kx-control col-sm-4 col-lg-4 col-xl-4 col-md-4 col-12 fix",
                  "order": 10,
                  "required": true,
                  "visible": false,
                  "default": true,
                  "type": "Boolean",
                  "component": "checkbox",
                  "name": "rightRoute"
                },
                {
                  "label": "field.label.right_time",
                  "class_name": "kx-control col-sm-4 col-lg-4 col-xl-4 col-md-4 col-12 fix",
                  "order": 11,
                  "required": true,
                  "visible": false,
                  "default": true,
                  "type": "Boolean",
                  "component": "checkbox",
                  "name": "rightTime"
                }
              ],
              "title": ""
            },
            {
              "class_name": "null",
              "order": 2,
              "layout_type": "two-column",
              "fields": [
                {
                  "label": "field.label._start_time",
                  "class_name": "kx-control col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6 fix",
                  "order": 1,
                  "type": "date",
                  "selected": true,
                  "visible": false,
                  "component": "timepicker",
                  "locale": {
                    "format": "HH:mm:ss"
                  },
                  "timePicker": true,
                  "timePickerSeconds": false,
                  "timePicker24Hour": false,
                  "timePickerIncrement": 1,
                  "name": "startTime"
                },
                {
                  "label": "field.label.end_time",
                  "class_name": "kx-control col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6 fix",
                  "order": 2,
                  "type": "date",
                  "selected": true,
                  "visible": false,
                  "component": "timepicker",
                  "locale": {
                    "format": "HH:mm:ss"
                  },
                  "timePicker": true,
                  "timePickerSeconds": false,
                  "timePicker24Hour": false,
                  "timePickerIncrement": 1,
                  "name": "endTime"
                },
                {
                  "order": 1,
                  "type": "String",
                  "component": "hidden",
                  "name": "itemCode"
                },
                {
                  "label": "field.label.witnessed_by",
                  "class_name": "kx-control col-sm-6 col-lg-6 col-xl-6 col-md-6 col-12 fix",
                  "order": 3,
                  "type": "String",
                  "component": "textbox",
                  "name": "witnessedBy"
                },
                {
                  "label": "field.label.comment",
                  "class_name": "kx-control col-sm-6 col-lg-6 col-xl-6 col-md-6 col-12 fix",
                  "order": 4,
                  "type": "String",
                  "component": "textbox",
                  "name": "comment"
                }
              ]
            },
            {
              "class_name": "null",
              "order": 3,
              "layout_type": "two-column",
              "fields": [
                {
                  "component": "hidden",
                  "name": "defaultQuantity"
                },
                {
                  "component": "hidden",
                  "name": "volumeStrength"
                },
                {
                  "label": "field.label.is_multidose",
                  "class_name": "kx-control col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 fix",
                  "order": 20,
                  "type": "Boolean",
                  "component": "checkbox",
                  "name": "is_multidose"
                },
                {
                  "label": "field.label.remarks",
                  "component": "textarea",
                  "class_name": "kx-control col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 fix ",
                  "order": 14,
                  "visible": false,
                  "required": true,
                  "maxlength": 256,
                  "type": "String",
                  "name": "remark"
                }
              ]
            }
          ]
        }
      }
      arr.push(administerObj)
    }
    if (this.gridData['item_consumption_capability'] && this['input'] != 'et_monitoring_chart') {
      arr.push({
        "action": "popup_form",
        "label": "field.label.item_consumption",
        "title": "Item Consumption",
        "dependent_fields2BindData": "id",
        "args": "id",
        "resource": 'stimulation_chart_details',
        "auto_refresh": false,
        "api_action":"item_consumption",
        "decorator": "ProtocolAdminsiterDecorator",
        "conditions": [{
          "expression": conditionObj['itemConsumptionConditions'] ? conditionObj['itemConsumptionConditions']:("item['status'] == 'Pending'")
        }],
        "form": this.itemConsumptionForm(undefined, true),
      })
    }
    let delCap = {
      "action": "confirm",
      "label": "button.delete",
      "auto_refresh": false,
      "permission_required": false,
      "message": "Are you sure you want to delete this record?",
      "conditions": [
        {
          "expression": "item && item.id != undefined && !item.isDosageRow && !item.order_sent"
        }
      ],
      "datasource": {
        "action": "DELETE",
        "resource": "patient_assigned_protocols_details",
        "application": "emr"
      }
    }
    let startTimeCap = {
      "action": "confirm",
      "label": "Start",
      "auto_refresh": false,
      "permission_required": false,
      "args": "id",
      "dependent_fields2BindData": "id",
      "message": "Are you sure you want to Start Infusion?",
      "conditions": [
        {
          "expression": "item && item.id != undefined && !item.isDosageRow && item.order_sent && item.infusion_order && item.infusion_order==true && !item.start_time &&item.status == 'Given'"
        }
      ],
      "datasource": {
        "action": "START_TIME",
        "resource": "patient_assigned_protocols_details",
        "application": "emr"
      }
    }
    let endTimeCap = {
      "action": "confirm",
      "label": "Complete",
      "auto_refresh": false,
      "permission_required": false,
      "args": "id",
      "dependent_fields2BindData": "id",
      "message": "Are you sure you want to Complete Infusion?",
      "conditions": [
        {
          "expression": "item && item.id != undefined && !item.isDosageRow && item.order_sent && item.infusion_order && item.infusion_order==true && item.start_time && item.stop_time==0"
        }
      ],
      "datasource": {
        "action": "STOP_TIME",
        "resource": "patient_assigned_protocols_details",
        "application": "emr"
      }
    }
    let pauseInfusionCap = {
      "action": "confirm",
      "label": "Pause",
      "args": "id",
      "dependent_fields2BindData": "id",
      "auto_refresh": false,
      "permission_required": false,
      "message": "Are you sure you want to Pause Infusion?",
      "conditions": [
        {
          "expression": "item && item.id != undefined && !item.isDosageRow && item.order_sent && item.infusion_order && item.infusion_order==true && item.start_time && item.stop_time==0 && (!item.time_series || item.time_series.length == 0 || item.time_series[item.time_series.length - 1].continue_time)"
        }
      ],
      "datasource": {
        "action": "PAUSE_TIME",
        "resource": "patient_assigned_protocols_details",
        "application": "emr"
      }
    }
    let continueInfusionCap = {
      "action": "confirm",
      "label": "Continue",
      "auto_refresh": false,
      "permission_required": false,
      "message": "Are you sure you want to Continue Infusion?",
      "conditions": [
        {
          "expression": "item && item.id != undefined && !item.isDosageRow && item.order_sent && item.infusion_order && item.infusion_order==true && item.start_time && item.stop_time==0 && item.time_series && item.time_series.length > 0 && !item.time_series[item.time_series.length - 1].continue_time"
        }
      ],
      "datasource": {
        "action": "CONTINUE_TIME",
        "resource": "patient_assigned_protocols_details",
        "application": "emr"
      }
    }
    if (this.patient_protocol) {
      arr.push(delCap);
      arr.push(startTimeCap)
      arr.push(endTimeCap)
      arr.push(pauseInfusionCap)
      arr.push(continueInfusionCap)
    }
    let _updateDoseCapability = {
      "action": "popup_form",
      "label": "Change Dosage",
      "title": "Update Dosage",
      "dependent_fields2BindData": "id",
      "args": "id",
      "auto_refresh": false,
      "application": "emr",
      "api_action": "MODIFY",
      "resource": "patient_assigned_protocols_details",
      "successMessage": "Updated Successfully",
      "type": "mar_administration",
      "decorator": "UpdateProtocolDosageDecorator",
      "conditions": [
        {
          "expression": "item && item.serviceItemName !== undefined  && item.serviceType_code=='procedure' "
        }
      ],
      "form": {
        "blocks": [
          {
            "name": "basic_information",
            "class_name": "null",
            "order": 1,
            "layout_type": "two-column",
            "fields": [
              {
                "order": 1,
                "label": "field.label.itemName",
                "class_name": "kx-control col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6 fix",
                "name": "serviceItemName",
                "component": "textbox",
                "disabled": true,
                "populate_field": true,
                "type": "String",
              },
              {
                "label": "field.label.qty",
                "class_name": "kx-control col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6 fix",
                "order": 3,
                "name": "quantity",
                "component": "numberbox",
                "type": "number",
                "required": true,
                "calculation": false,
                "default": 1
              },
              {
                "label": "GTV",
                "class_name": "kx-control col-12 col-sm-3 col-md-3 col-lg-3 col-xl-3 fix",
                "order": 4,

                "min": 0,
                "type": "Int",
                "setDefault": false,

                "component": "numberbox",
                "name": "GTV"
              },
              {
                "label": "CTV",
                "class_name": "kx-control col-12 col-sm-3 col-md-3 col-lg-3 col-xl-3 fix",
                "order": 5,

                "min": 0,
                "type": "Int",
                "setDefault": false,

                "component": "numberbox",
                "name": "CTV"
              },
              {
                "label": "PTV",
                "class_name": "kx-control col-12 col-sm-3 col-md-3 col-lg-3 col-xl-3 fix",
                "order": 6,

                "min": 0,
                "type": "Int",


                "component": "numberbox",
                "name": "PTV"
              },
              {
                "label": "field.label.unit",
                "class_name": "kx-control col-12 col-sm-3 col-md-3 col-lg-3 col-xl-3 fix",
                "order": 7,
                "name": "dose_unit",

                "component": "dropdown",
                "type": "String",
                "getterKey": "code",
                "getterValue": "display",
                "datasource": {
                  "application": "system-management",
                  "resource": "valueset",
                  "query_id": "get_valueset_by_id_flat",
                  "args": "resourceId:dose_unit,system:karexpert",
                  "key": "id"
                }
              },
              {
                "label": "Total Dose",
                "class_name": "kx-control col-12 col-sm-3 col-md-3 col-lg-3 col-xl-3 fix",
                "order": 8,
                "type": "Int",
                "disabled": true,
                "component": "textbox",
                "name": "total_dose"
              }
            ],
            "title": ""
          }
        ]

      }
    }
    if (this.patient_protocol && this.isRadiationTherapy) {
      arr.push(_updateDoseCapability)
    }
    //arr.push(_updateDoseCapability)
    return arr;
  }
  itemConsumptionForm(conditionObj?: any,batch?:any) {
    let obj: any = {
          "blocks": [
            {
              "name": "medication_name",
              "class_name": "null",
              "order": 1,
              "layout_type": "three-column",
              "fields": [
                {
                  "label": "field.label.store",
                  "getterKey": "id",
                  "req_keys": "all",
                  "getterValue": "name",
                  "class_name": "kx-control col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6 fix",
                  "order": 1,
                  "type": "String",
                  "populate_field": true,
                  "required": true,
                  "component": "dropdown",
                  "datasource": {
                    "application": "inventory-management",
                    "resource": "store",
                    "query_id": "GET_STORE_BY_PATIENT_TYPE",
                    "args": "patient_type:OP",
                    "filter": "status:active"
                  },
                  "dependents": [
                  ],
                  "name": "storeId"
                },
                {
                  "component": "hidden",
                  "name": "billing_category_id"
                },
                {
                  "component": "hidden",
                  "name": "administer_dose"
                },
                {
                  "label": "field.label.item_name",
                  "order": 1,
                  "visible": true,
                  "type": "String",
                  "disabled": true,
                  "component": this.patient_protocol ? "textarea" : "textbox",
                  "name": "itemName"
                },
                 {
                  "label": "field.label.total_quantity",
                  "order": 2,
                  "type": "String",
                  "disabled": true,
                  "component": "numberbox",
                  "name": "total_quantity"
                },
                {
                  "label": "field.label.qty/dosage",
                  "order": 1,
                  "type": "String",
                  "disabled": true,
                  "component": this.patient_protocol ? "textarea" : "textbox",
                  "name": "administer_dose"
                },
                {
                  "component": "hidden",
                  "name": "initialQty"
                },
                {
                  "component": "hidden",
                  "name": "payer_amount"
                },
                {
                  "component": "hidden",
                  "name": "gst"
                }, {
                  "component": "hidden",
                  "name": "discount"
                },
                {
                  "component": "hidden",
                  "name": "sgst"
                }, {
                  "component": "hidden",
                  "name": "igst"
                },
                {
                  "component": "hidden",
                  "name": "tax"
                }, {
                  "component": "hidden",
                  "name": "cgst"
                },
                {
                  "component": "hidden",
                  "name": "service_selling_amount"
                }, {
                  "component": "hidden",
                  "name": "service_mrp"
                },
                {
                  "component": "hidden",
                  "name": "total_amount"
                },
                {
                  "component": "hidden",
                  "name": "itemCode"
                },
                {
                  "component": "hidden",
                  "name": "price"
                },
                {
                  "component": "hidden",
                  "name": "patient_amount"
                },
                {
                  "component": "hidden",
                  "name": "net_amount"
                },
                {
                  "component": "hidden",
                  "name": "batchId"
                },
                {
                  "component": "hidden",
                  "name": "batch_qoh"
                },
                {
                  "component": "hidden",
                  "name": "qoh"
                },
                {
                  "component": "hidden",
                  "name": "expiry_Date"
                },
                {
                  "component": "hidden",
                  "name": "expiryDate"
                },
                {
                  "component": "hidden",
                  "name": "freeData"
                },
                {
                  "component": "hidden",
                  "name": "billNo"
                },
                {
                  "component": "hidden",
                  "name": "vr"
                },
                {
                  "component": "hidden",
                  "name": "epr"
                },
                {
                  "component": "hidden",
                  "name": "isBlock"
                },
                {
                  "component": "hidden",
                  "name": "batchNo"
                }
              ]
            }
          ]
        }
    if(batch == true){
      let batchObj = {
                  "label": "field.label.batch_no",
                  "required": true,
                  "getterKey": "id",
                  "order": 1,
                  "getterValue": "batchNo",
                  "class_name": "kx-control col-6 col-sm-6 col-md-6 col-lg-6 col-xl-6 fix",
                  "component": "dropdown",
                  "name": "batch_id",
                  "req_keys": "all",
                  "format": "(item) => `${item.batchNo}`",
                  "populate_field": true,
                  "class_conditions": [
                    {
                      "expression": " item['expiringSoon'] == true",
                      "class": "danger"
                    }
                  ],
                  "datasource": {
                  },
                  "dependents": [
                    {
                      "dependent_field": "batchNo",
                      "value": "batchNo",
                      "action": "populate_field"
                    },
                    {
                      "dependent_field": "batchId",
                      "value": "batchId",
                      "action": "populate_field"
                    },
                    {
                      "dependent_field": "qoh",
                      "value": "total_stock_quantity",
                      "action": "populate_field"
                    },
                    {
                      "dependent_field": "batch_qoh",
                      "value": "itemQty",
                      "action": "populate_field"
                    },
                    {
                      "action": "populate_field",
                      "dependent_field": "expiry_Date",
                      "value": "expiryDate"
                    },
                    {
                      "action": "populate_field",
                      "dependent_field": "expiryDate",
                      "value": "expiryDate"
                    },
                    {
                      "action": "populate_field",
                      "dependent_field": "freeData",
                      "value": "freeData"
                    },
                    {
                      "action": "populate_field",
                      "dependent_field": "billNo",
                      "value": "billNo"
                    },
                    {
                      "action": "populate_field",
                      "dependent_field": "vr",
                      "value": "vr"
                    },
                    {
                      "action": "populate_field",
                      "dependent_field": "epr",
                      "value": "epr"
                    },
                    {
                      "action": "populate_field",
                      "dependent_field": "isBlock",
                      "value": "isBlock"
                    }
                  ]
      }
      obj.blocks[0].fields.push(batchObj)
    }
    if(conditionObj){
      let daysObj =  {
                  "label": "field.label.days",
                  "order": 1,
                  "populate_field": true,
                  "getterKey": "id",
                  "getterValue": "no_of_days",
                  "view_key": "no_of_days",
                  "class_name": "kx-control col-12 col-sm-4 col-md-4 col-lg-4 col-xl-4 fix",
                  "req_keys": "all",
                  "type": "Array",
                  "component": "searchselect",
                  "stopSorting": true,
                  "required": true,
                  "datasource": {
                    "application": "emr",
                    "resource":(this['input'] == 'et_monitoring_chart' ? "embryo_chart_details" : "stimulation_chart_details"),
                    "query_id": "GET_NO_OF_DAYS_MEDICINE_PRESENT",
                    "args": "itemCode:!!!itemCode!!!" + ",uhId:" + this.apiData?.[0]?.uhId + ",parent_id:" + this.apiData?.[0]?.parent_id,
                    "key": "id"
                  },
                  "name": "days"
      }
      obj.blocks[0].fields.push(daysObj)
    }
    if (!conditionObj) {
      obj.blocks[0].fields = obj.blocks[0].fields.filter(field => field.name != 'total_quantity');
    }
    return obj
  }

  pacClearance(cb) {
    let args = "encounter_id:" + this.apiData[0].encounter_id + ",uhId:" + this.apiData[0].uhId + ",parent_id:" + this.apiData[0].parent_id
    this.baseService.get("VALIDATE_PAC_CLEARANCE", args, "stimulation_chart_details", "emr").subscribe(
      (res: any) => {
        this.alerts.info(res.message);
        cb(true)
      });
  }

  dataSetting(data: any[], type?): any[] {
    const grouped: Record<string, any> = {};
    const resultKeys = [
      { key: 'right_ovary_folicile_size', value: 'Right Ovary Follicle Size' },
      { key: 'left_ovary_folicile_size', value: 'Left Ovary Follicle Size' },
      { key: 'endometrial_thickness', value: 'Endometrial Thickness' },
      { key: 'cyst', value: 'CYST' },
      { key: 'morphology', value: 'Morphology' }
    ];
    data.forEach(item => {
      let name =
        item.itemName ||
        item.displayName ||
        item.surgeryName ||
        item.serviceItemName;
      if (type == 'surgery') {
        name = 'Surgery'
      }
      if (item.no_of_sittings) {
        item['no_of_days'] = item.no_of_sittings
      }
      const key = `day${item.no_of_days}`;
      const idKey = `id${item.no_of_days}`;
      if (name && item.visit != true) {
        grouped[name] ??= {
          id: item.id || item._id,
          serviceId: item.serviceId || item.serviceItemId,
          serviceItemName: name,
          name,
          uhId: item.uhId,
          encounter_id: item.encounter_id,
          itemCode: item.itemCode,
          hasFolliculogram: false,
          serviceItemCode: item.serviceItemCode,
          GTV: item.GTV || '',
          CTV: item.CTV || '',
          PTV: item.PTV || '',
          dose_unit: item.dose_unit,
          total_dose: item.total_dose,
          type_code: item.type_code || '',
          serviceType_code: item.serviceType_code || '',
        };
        grouped[name][key] = item.status;
        grouped[name][idKey] = {
          id: item.id || item._id,
          status: item.status,
          [key]: item.status,
          greaterThanCurrentDate: (item.date > new Date().setHours(0, 0, 0, 0)) ? true : false,
          serviceId: item.serviceId || item.serviceItemId,
          serviceItemName: name,
          name: name,
          quantity: item.quantity,
          GTV: item.GTV || '',
          CTV: item.CTV || '',
          PTV: item.PTV || '',
          dose_unit: item.dose_unit,
          total_dose: item.total_dose,
          type_code: item.type_code || '',
          serviceType_code: item.serviceType_code || '',
          order_sent: item.order_sent || false,
        };
        if (this.isRadiationTherapy && type === 'clinical' && this.isRadiationTherapy && item.serviceType_code == 'procedure') {
          const dosageRowKey = name + '_dosage';
          grouped[dosageRowKey] ??= {
            id: (item.id || item._id) + '_dosage',
            serviceId: item.serviceId || item.serviceItemId,
            serviceItemName: name + ' Dosage',
            name: 'Dosage Detail - ' + name,
            uhId: item.uhId,
            encounter_id: item.encounter_id,
            itemCode: item.itemCode,
            serviceItemCode: item.serviceItemCode,
            GTV: '',
            CTV: '',
            PTV: '',
            dose_unit: item.dose_unit,
            total_dose: item.total_dose,
          };
          const gtv = item.GTV !== undefined && item.GTV !== null && item.GTV !== '' ? item.GTV : '-';
          const ctv = item.CTV !== undefined && item.CTV !== null && item.CTV !== '' ? item.CTV : '-';
          const ptv = item.PTV !== undefined && item.PTV !== null && item.PTV !== '' ? item.PTV : '-';
          const total = (item.total_dose !== undefined && item.total_dose !== null && item.total_dose !== '') ? item.total_dose : '-';
          const dosageValue = `<div style="font-size: 8.5px; line-height: 1.2; text-align: center; font-family: inherit;">` +
            `<div style="color: #475569; letter-spacing: -0.2px;">GTV:${gtv} CTV:${ctv} PTV:${ptv}</div>` +
            `<div style="font-weight: 800; color: #1d4ed8; margin-top: 1px;">Total: <b>${total}</b></div>` +
            `</div>`;
          grouped[dosageRowKey][key] = dosageValue;
          grouped[dosageRowKey][idKey] = {
            id: (item.id || item._id) + '_dosage',
            status: dosageValue,
            [key]: dosageValue,
            isDosageRow: true
          };
        }
      }
      if (type == 'clinical') {
        if (item.service_result?.folliculogram) {
          grouped[name].hasFolliculogram = true;
        }
        if (item.clinical_value && item.status == 'Completed') {
          grouped[name][key + 'clinical_value'] = item.clinical_value
        }
      }
      if (type == 'clinical' && item.visit != true) {
        resultKeys.forEach(res => {
          if (item.service_result?.[res.key] !== undefined) {
            if (this.from_History &&item.service_result?.folliculogram) {
              grouped[name].hasFolliculogram = true;
            }
            grouped[res.value] ??= {
              id: item.id || item._id,
              serviceId: item.serviceId || item.serviceItemId,
              serviceItemName: res.value,
              name: res.value
            };
            grouped[res.value][key] = item.service_result[res.key];
            grouped[res.value][idKey] = {
              id: item.id || item._id,
              status: item.service_result[res.key],
              [key]: item.service_result[res.key],
              serviceId: item.serviceId || item.serviceItemId,
              serviceItemName: res.value,
              name: res.value
            };
          }
        });
      }
    });
    return Object.values(grouped);
  }

  getEmbryoRankingDay2(
    cells: any,
    regularity: string,
    fragmentation: string,
    mnb: string,
    grade: string
  ): string {
    // Case 1: A → Excellent
    if (cells && parseInt(cells) === 4 && regularity === "Equal" && fragmentation === "0-10%" && mnb === "No" && grade === "A") {
      return "Excellent";
    }

    // Case 2: B → Good
    if (cells && parseInt(cells) === 4 && regularity === "Equal" && fragmentation === "11-25%" && mnb === "No" && grade === "B") {
      return "Good";
    }

    // Case 3: C → Fair
    if (cells && parseInt(cells) >= 2 && parseInt(cells) <= 6 && regularity === "Equal" && fragmentation === "25-50%" && mnb === "No" && grade === "C") {
      return "Fair";
    }

    // Case 4: D → Poor
    if (cells && (parseInt(cells) >= 2 && parseInt(cells) <= 6 && regularity === "Unequal" && mnb === "Yes" && grade === "D") || mnb === "Yes") {
      return "Poor";
    }

    return "-1";
  }

  getEmbryoRankingDay4(heading: any,
    grade: any,
  ) {
    if (heading === "Cavitating" && grade === "A") {
      return "Excellent";
    }

    // Case 2: Compacting → Grade B → Good
    if (heading === "Compacted" && grade === "B") {
      return "Good";
    }

    // Case 2: Compacting → Grade B → Good
    if (heading === "Compacting" && grade === "C") {
      return "Fair";
    }

    // Case 2: Compacting → Grade B → Good
    if (heading === "Non compacted / Any no of cells" && grade === "D") {
      return "Poor";
    }

    return "-1"
  }

  getEmbryoRankingDay3(
    compaction: string,
    cells: any,   // e.g. "less than 6", "6 to 10", "-" etc
    regularity: string,
    fragmentation: string,
    mnb: string,
    grade: string
  ): string {
    // Case 1: Compacted → Grade A → Excellent
    if (compaction === "Compacted" && grade === "A") {
      return "Excellent";
    }

    // Case 2: Compacting → Grade B → Good
    if (compaction === "Compacting" && grade === "B") {
      return "Good";
    }

    // Case 3: 6–10 cells, Equal, 0–25%, No, Grade B → Good
    if (cells && ((parseInt(cells) >= 6 && parseInt(cells) <= 10)) &&
      regularity === "Equal" &&
      fragmentation === "0-25%" &&
      mnb === "No" &&
      grade === "B"
    ) {
      return "Good";
    }

    // Case 4: <6 parseInt(cells), Equal/Unequal, >25%, No, Grade C → Fair
    if (cells && (parseInt(cells) < 6) &&
      (regularity === "Equal" || regularity === "Unequal") &&
      fragmentation === ">25%" &&
      mnb === "No" &&
      grade === "C"
    ) {
      return "Fair";
    }

    // Case 5: 6–10 parseInt(cells), Unequal, >25%, No, Grade C → Fair
    if (cells && (parseInt(cells) >= 6 && parseInt(cells) <= 10) &&
      regularity === "Unequal" &&
      fragmentation === ">25%" &&
      mnb === "No" &&
      grade === "C"
    ) {
      return "Fair";
    }

    // Case 6: Any parseInt(cells), Equal/Unequal, (0–25% or >25%), Yes, Grade D → Poor
    if ((regularity === "Equal" || regularity === "Unequal") &&
      (fragmentation === "0-25%" || fragmentation === ">25%") &&
      mnb === "Yes" &&
      grade === "D"
    ) {
      return "Poor";
    }

    // Case 7: Compacting, 6–10 parseInt(cells), Grade D → Poor
    if (
      (cells === "Uncleaved" || (compaction === "Compacting" &&
        (parseInt(cells) >= 6 && parseInt(cells) <= 10))) &&
      grade === "D"
    ) {
      return "Poor";
    }

    // Default case
    return "-1";
  }

  getEmbryoRankingDay5(expansion: any, te: any, icm: any, grade: any): number | string {
    const exp = Number(expansion);
    const teU = te?.toUpperCase() || '';
    const icmU = icm?.toUpperCase() || '';
    const gradeU = grade?.toUpperCase() || '';

    // 1–2 with N/A and Disabled grade
    if ((exp === 1 || exp === 2) && teU === 'N/A' && icmU === 'N/A' && gradeU === 'DISABLED') {
      return 'Disabled';
    }

    // Good Blastocyst
    if ((exp >= 4 && exp <= 6) && ['A', 'B'].includes(teU) && ['A', 'B'].includes(icmU) && gradeU === 'GOOD BLASTOCYST') {
      return "1";
    }

    // Moderate Blastocyst
    if (exp === 3 && ['A', 'B'].includes(teU) && ['A', 'B'].includes(icmU) && gradeU === 'MODERATE BLASTOCYST') {
      return "2";
    }

    // Poor cases
    if ((exp >= 4 && exp <= 6) && teU === 'C' && gradeU === 'POOR') return "4";
    if (exp === 3 && teU === 'C' && gradeU === 'POOR') return "5";
    if ((exp >= 4 && exp <= 6) && icmU === 'C' && gradeU === 'POOR') return "6";
    if (exp === 3 && icmU === 'C' && gradeU === 'POOR') return "7";

    // Default
    return '-1';
  }



  removeAdditionalFields(payload, gridRow) {
    let fieldsToClear = ['standard_codes', 'isBloodRequest', 'timeBased', 'department_name', 'subDepartment_name', 'department_id', 'subDepartment_id', 'priorityCode', 'serviceItemCode', 'fullName', 'name', 'serviceItemName', 'serviceType_Id', 'serviceType', 'service_priority_id', 'service_priority', 'priority', 'serviceItemId', 'serviceType_code', 'serviceDate']
    if (payload) {
      payload.forEach((ele) => {
        if (ele['plan'] && ele['plan'] != "Cryo") {

          fieldsToClear.forEach((field) => {
            if (!(field in ele)) return;   // optional safety
            ele[field] = field === 'serviceDate' ? null : '';
          });
        }
      })
      return payload;
    }
    else if (gridRow) {
      fieldsToClear.forEach((key) => {
        if (!gridRow?.controls?.[key]) {
          return
        }
        gridRow.controls[key].setValue(key === 'serviceDate' ? null : '')
      })
      return gridRow;
    }

  }
  onSaveFinished(stage) {
    //console.log(this.formComponenet.form,"form component")
    this.loader.showSpinner()
    let payload = JSON.parse(JSON.stringify(this.editableGridData))
    const carePlanFields = [
      'care_plan_request_id',
      'care_plan_id',
      'care_plan_name',
      'care_plan_milestone_id',
      'care_plan_milestone_name',
      'care_plan_no_of_cycle',
      'is_part_of_care_plan',
      'care_plan_milestone_code',
      'care_plan_ref_no',
      'care_plan_type_name',
      'care_plan_type_code',
      'care_plan_assignment_date',
      'art_role',
      'art_category_name',
      'art_role_name',
      'art_category',
      'treatingDoctor',
      'treatingDoctorId',
      'treatingDoctorSpeciality',
      'treatingDoctorSpecialityCode',
      'serviceRequestId'
    ];
    let mand = false;
    let fields = ['plan', 'witnessId', 'embryologistId', 'grade', 'ranking']
    let cryoMandFields = ['priority', 'serviceItemId', 'serviceType_code']
    let uploadDocumentEmpty = "";
    var currentDateTime = new Date().getTime();
    if (payload?.some(el => el?.date_and_time > currentDateTime)) {
      this.loader.hideSpinner()
      let date = new Intl.DateTimeFormat("en-CA").format(new Date(this.formComponenet.form.value['date_and_time']))
      let errMsg = "Grading start date is " + date + " do you want to continue ?";
      const dialogRef = this.modalService.confirm('CONFIRM', errMsg, ModalSize.Sm);
      dialogRef.subscribe(res => {
        if (res) {
          this.saveDataFinished(payload, uploadDocumentEmpty, currentDateTime, fields, mand, cryoMandFields, carePlanFields, stage)
        }
      })
      return;
    } else {
      this.saveDataFinished(payload, uploadDocumentEmpty, currentDateTime, fields, mand, cryoMandFields, carePlanFields, stage)
    }
  }

  saveDataFinished(payload, uploadDocumentEmpty, currentDateTime, fields, mand, cryoMandFields, carePlanFields, stage) {
    for (let i = 0; i < payload.length; i++) {
      const element = payload[i];
      element['serviceDate'] = currentDateTime;
      element['serviceType'] = "Cryopreservation";
      element['priority'] = "Routine";
      element['priorityCode'] = "routine";
      element['serviceType_code'] = "cryopreservation"
      if ((element.documentId == "" || element.documentId == undefined) && this.activeTab != 'grading_days0' && element.grading_status != 'Completed') {
        uploadDocumentEmpty = payload.filter((x) => ((x.documentId == "" || x.documentId == undefined) && x.grading_status != 'Completed')).map(item => item.oocyte_no).join(',')
        mand = true;
        break;
      }
      for (let i = 0; i < fields.length; i++) {
        const ells = fields[i];
        if ((element[ells] == "" && element[ells] != undefined && element.grading_status != 'Completed')) {
          if (element.fertilisation_status == 'Unfertilised' && ells == 'grade') {
          } else {
            mand = true;
            break;
          }
        }
      }
      for (let i = 0; i < cryoMandFields.length; i++) {
        const ells = cryoMandFields[i];
        if (element?.['plan'] == "Cryo" && element?.[ells] == "" && element?.[ells] != undefined && element?.grading_status != 'Completed' || element?.[ells] === null) {
          mand = true;
          break;
        }
      }
    }
    if (mand) {
      let err = ""
      if (uploadDocumentEmpty != "") {
        err = "Please fill Mandatory fields" + " and upload document for oocyte no " + uploadDocumentEmpty + "."
      } else { err = "Please fill Mandatory fields" }
      this.formService.alerts.error(err);
      this.loader.hideSpinner()
      return;
    }
    payload.forEach(element => {
      element['next_date_and_time'] = this.formComponenet.form.value['next_date_and_time'];
      element['date_and_time'] = this.formComponenet.form.value['date_and_time'];
      element['grading_status'] = (stage == 'draft') ? 'draft' : 'Completed';
      if (element['embryoscope'] === '') {
        element['embryoscope'] = false;
      }
      if (this.patientDetails) {
        carePlanFields.forEach(field => {
          if (
            element[field] === undefined ||
            element[field] === null ||
            element[field] === ''
          ) {
            element[field] = this.patientDetails[field] ?? '';
          }
        });
      }
    });
    if (Array.isArray(payload)) {
      payload = this.removeAdditionalFields(payload, null)
    }
    if (stage == 'skip_next') {
      this.loader.hideSpinner()
      this.skipdays('next')
    } else {
      this.gridApicall(payload)
    }
  }

  gridApicall(payload) {
    let action = (this.activeTab == 'grading_days0') ? 'SUBMIT_DAY_ZERO' : (this.activeTab == 'grading_days1') ? 'SUBMIT_DAY_ONE' : (this.activeTab == 'grading_days2') ? 'SUBMIT_DAY_TWO' : (this.activeTab == 'grading_days3') ? 'SUBMIT_DAY_THREE' : (this.activeTab == 'grading_days4') ? 'SUBMIT_DAY_FOUR' : (this.activeTab == 'grading_days5') ? 'SUBMIT_DAY_FIVE' : (this.activeTab == 'grading_days6') ? 'SUBMIT_DAY_SIX' : (this.activeTab == 'grading_days7') ? 'SUBMIT_DAY_SEVEN' : ''
    this.formService.baseService.action(payload, action, "emr", "embryo_grading").subscribe(
      (res: any) => {
        if (res.errCode == 0) {
          this.formService.alerts.success("Request Successful");
          this.activeTab = undefined
          setTimeout(() => {
            this.getGradingData(this.jsonResource, true)
          }, 1000);
        } else {
          if (res.errCode == -1) {
            this.formService.alerts.error(res?.message);
          }
          this.loader.hideSpinner()
        }
      });
  }

   getGradingData(activeTab?, isFromTabChange?) {
    let data = this.getCurrentData()
    data.uhId = data.uhId
    let args = this['historyPopup'] ? `uhId:${data?.uhId},cycle_no:${this['data']?.cycle_no},care_plan_id:${this['data']?.care_plan_id},embryoCycle_no:${this['data']?.embryoCycle_no}` : `uhId:${data?.uhId}`;
    let query_id = this['historyPopup'] ? 'GET_EMBRYO_GRADING_HISTORY' : 'GET_GRADING_DATA'
    this.gridData['activeDayKey'] = 'Day_' + sessionStorage.getItem('activeTab').match(/\d+/)?.[0]
    let filter = "no_of_day:" + this.gridData['activeDayKey']
    this.baseService.get(query_id, args, "embryo_grading", "emr", filter).subscribe(
      (res: any) => {
        let data = res.resource
        this.apiData = data;
        if (isFromTabChange) {
          this.embryoGrading(activeTab)
          this.activeTab = activeTab
        }
        if (res.resource.length > 0) {
          this.grading_data = res.resource
          if (this.grading_data) {
            const isChartClosed =
              Array.isArray(this.grading_data)
                ? this.grading_data.find((ele) => ele?.isChartClosed == true)
                : this.grading_data?.isChartClosed;

            if (isChartClosed) {
              if (!this.cycleStatus) {
                this.cycleStatus = 'Status: Closed'
                this.isStopBtnVisible = false
                this.viewOnly = true;
              }
            }
            else {
              this.isStopBtnVisible = true
            }
          }
        } else {
          this.grading_data = []
        }
        setTimeout(() => {
          this.loaders.hideSpinner()
        }, 1000)
      });

  }
  getCurrentData() {
    let dataString = sessionStorage.getItem("currentData")
    try {
      if (dataString) {
        let parsedData = JSON.parse(dataString)
        return parsedData

      }
    }
    catch (e) {
      console.log("error in parsing currentData")
      return {}
    }
    return {}
  }
  openModalPopup() {
    var data = {
      "data": this.patient_protocol_info,
      "layout_type": "simple",
      "resource": "patient_assigned_protocols",
      "application": "emr",
      "action": "MODIFY",
      "customButton": {
        "Modify": [
          {
            "label": "Deactivate"
          }
        ]
      },
      title: "Are you sure you want to Deactivate Protocol",

      "form": {
        "blocks": [
          {
            "name": "basic_information",
            "class_name": "null",
            "order": 1,
            "layout_type": "one-column",
            "fields": [
              {
                "label": "field.label.remarks",
                "class_name": "kx-control col-lg-12 col-md-12 col-sm-12 col-xl-12 mb-12 fix image-upload",
                "order": 1,
                "type": "String",
                "required": true,
                "minlength": 2,
                "component": "textarea",
                "name": "closed_protocol_remarks"
              },
              {
                "component": "hidden",
                "type": "Boolean",
                "default": true,
                "value": true,
                "name": "isProtocolClosed"
              }

            ],
            "title": ""
          }
        ]
      }
    }

    this.smartModalService.open(PopupFormComponent, data, 'Deactivate Protocol Remark', ModalSize.Sm).subscribe(
      (res) => {
        if (res && res.result && res.result.errCode == 0) {
          this.viewOnly = true;

          this.getToxicityData(this.patient_protocol_info)
          this.dataCallForProtocolHeader(this.patient_protocol_info)
          this.isStopBtnVisible = false;
          this.from_History = true;
          this.initializeFields(1);
          this.cycleStatus = "Protocol Deactivated";
          //this.closeChart.emit();
        }
      },
      err => {
        console.error("Error in getting data : ", err)
      }
    )
  }
  handleClose() {
    if (this.patient_protocol) {
      this.openModalPopup()
    }
    else {
      let result = {
        uhId: '',
        parent_id: ''
      }
      if (this['input'] == 'embryo_grading_format') {
        let data = this.getCurrentData()
        let uhId = data.uhId
        result.uhId = uhId
        result['parentId'] = this.apiData[0].parentId
        this.loaders.showSpinner()
        this.baseService.action(result, "CLOSE_CHART", "emr", "embryo_grading", undefined, undefined, undefined).subscribe((res: any) => {
          if (res.errCode == 0) {
            this.formService.alerts.success("Request Successful");
            this.viewOnly = true
            this.isStopBtnVisible = false;
            this.cycleStatus = "Status:Closed";
            this.viewOnly = true;
            // Force grid reload of CURRENT DAY
            const currentDay = this.jsonResource;
            this.activeTab = undefined;        // destroy grid
            this.medication_update_json = null;
            this.apiData = []
            // getGradingData recreates the grid, reloads the schema and hides the spinner
            // only after the data is back (hiding it here raced with the grid's own spinner).
            setTimeout(() => {
              this.getGradingData(currentDay, true)
            }, 0);
          } else {
            this.loaders.hideSpinner()
            this.alerts.error(res.message);
            return
          }
        }, (err: any) => {
          this.loaders.hideSpinner()
          return
        })
      }
      //  if (this['input'] == 'et_monitoring_chart') {
      if (this.apiData.length == 0) {
        this.alerts.error("Can not close, Cycle is not Started Yet!!!");
        return;
      }
      else if (this['input'] == 'et_monitoring_chart') {
        result = {
          uhId: this.apiData[0].uhId,
          parent_id: this.apiData[0].parent_id
        }
        this.baseService.action(result, "CLOSE_CHART", "emr", "embryo_chart_details", undefined, undefined, undefined).subscribe((res: any) => {
          if (res.errCode == 0) {
            this.alerts.success("Request Successful");
            //this.loaderService.hideSpinner()

            this.viewOnly = true
            this.dataCall();
          } else {
            //  this.loaderService.hideSpinner();
            this.alerts.error(res.message);
            return

          }
        }, (err: any) => {
          //this.loaderService.hideSpinner();
          //this.alerts.error("error");
          return
        })
      }
      else if (this['input'] == 'stimulation_chart') {
        result = {
          uhId: this?.apiData[0]?.uhId,
          parent_id: this?.apiData[0]?.parent_id
        }
        this.baseService.action(result, "CLOSE_CHART", "emr", "stimulation_chart_details", undefined, undefined, undefined).subscribe((res: any) => {
          if (res.errCode == 0) {
            this.formService.alerts.success("Request Successful");
            //this.loaderService.hideSpinner()
            this.viewOnly = true
            this.dataCall();
            //this.initializeFields(1);    

          } else {
            //this.loader.hideSpinner();
            this.alerts.error(res.message);
            return
          }
        }, (err: any) => {
          // this.loader.hideSpinner();
          //this.alerts.error("error");
          return
        })
      }
    }
  }
  bindDataToGrid(e) {
    if (this['input'] == 'stimulation_chart' || this['input'] == 'et_monitoring_chart' || this.patient_protocol) {
      setTimeout(() => {
        if (this.patient_protocol_info && this.patient_protocol) {
          this.getToxicityData(this.patient_protocol_info)
          this.dataCallForProtocolHeader(this.patient_protocol_info)
        }
        else {
          this.dataCall();
        }

      }, 50)
    }
  }

  skipdays(day) {
    let errMsg;
    let date = new Date(this.formComponenet.form.value['next_date_and_time'])
    const nextDate = date.getFullYear() + '-' + String(date.getMonth() + 1).padStart(2, '0') + '-' + String(date.getDate()).padStart(2, '0')
    if (day == 'today') {
      errMsg = "Are you sure you want to skip today ? Next visit date would be " + nextDate + " and day would be Day " + (parseInt(this.activeTab.slice(-1)) + 1) + "."
    } else {
      errMsg = "Are you sure you want to skip next visit ? Next visit date would be " + nextDate + " and day would be Day " + (parseInt(this.activeTab.slice(-1)) + 2) + "."
    }
    const dialogRef = this.modalService.confirm('CONFIRM', errMsg, ModalSize.Sm);
    dialogRef.subscribe(res => {
      if (res) {
        let payload = this.editableGridData
        payload.forEach(element => {
          element['next_date_and_time'] = this.formComponenet.form.value['next_date_and_time'];
          element['date_and_time'] = this.formComponenet.form.value['date_and_time'];
          element['grading_status'] = (day == 'today') ? 'Skip Today' : 'Completed';
          element['skipNextVisit'] = true
          if (element['embryoscope'] === '') {
            element['embryoscope'] = false;
          }
        })
        this.gridApicall(payload)
      } else {
      }
    });
  }
  buttonAction(event) {
    if (event?.actionType?.action === 'confirm') {
      const message = event.actionType.message || "Are you sure you want to delete this record?";
      const dialogRef = this.modalService.confirm('CONFIRM', message, ModalSize.Sm);
      dialogRef.subscribe(result => {
        if (result) {
          if (event.actionType.datasource) {
            this.loader.showSpinner();
            this.baseService.action(
              event.data,
              event.actionType.datasource.action,
              event.actionType.datasource.application,
              event.actionType.datasource.resource
            ).subscribe(
              (res: any) => {
                this.loader.hideSpinner();
                if (res.errCode == -1) {
                  this.alerts.error(res.message);
                } else {
                  this.alerts.success("Record Deleted Successfully");
                  this.dataCall();
                }
              },
              error => {
                this.loader.hideSpinner();
                this.alerts.error("API error");
              }
            );
          } else {
            //this.alerts.warning("No action datasource is defined for this delete capability.");
          }
        }
      });
    } else {
      super.buttonAction(event);
    }
  }

  buttonActionClinical(event) {
    const action = event?.action;
    let parentId = this.apiData[0].parent_id
    let data = { ...event.data, parentId: parentId, action: event?.actionType?.action }
    const dayNo = event?.actionType?.params?.day_no;
    if (dayNo) {
      data['day_no'] = dayNo;
    }
    if (event?.actionType?.action === 'open_follicle_chart' || event?.actionType?.action === 'open_follicle_data') {
      let popObj = {
        'data': data,
        "action": action,
        "getdata": true,
        "layout_type": "simple",
        "application": "emr",
        "title": event?.actionType?.action === 'open_follicle_chart' ? 'Follicular Growth Chart' : `Follicular Data for Day ${dayNo}`,
        "size": event?.actionType?.action === 'open_follicle_chart' ? DialogModalSize.Lg : DialogModalSize.Md,
      }
      this.dialogService.open(FollicularChartGridComponent, popObj).afterClosed.subscribe(response => {
      })
    }
    else {
      this.buttonAction(event)
    }
  }

  buildDayWiseData() {
    const result = [];

    const stim = this.gridData.stimulationData?.resource || [];
    const clinical = this.gridData.clinicalData?.resource || [];
    const medication = this.gridData.medicationData?.resource || [];
    console.log(clinical, "clinical Data")
    let surgeryHeading = (this['input'] == 'et_monitoring_chart' ? "Date of ET Surgery" : "Date of Surgery")
    const mensesRow = stim.find(x => x.name === 'Day of Menses');
    const stimRow = stim.find(x => x.name === (this.patient_protocol ? 'Date of Sitting' : 'Date of Stimulation'));
    const surgeryRows = this.gridData.surgeryGridData?.resource || [];
    const surgeryRow = stim.find(x => x.name === surgeryHeading);
    const toxicityRow = stim.find(x => x.name === 'Toxicity Detail') || [];
    const remarksData = this.gridData.remarksData?.resource || [];
    const followUpAdvice = this.gridData.followUpAdvice?.resource || [];
    const markDoneData = this.gridData.markDoneData?.resource || [];

    const totalDays = this.totalItems || 7;

    for (let i = 1; i <= totalDays; i++) {
      const dayKey = `day${i}`;

      const daySurgeries = surgeryRows.map(row => {
        const val = row[dayKey];
        return val ? { name: row.name, date: val } : null;
      }).filter(Boolean);

      result.push({
        day: `Day ${i}`,

        //  STIMULATION
        menses: mensesRow?.[dayKey] ?? '',
        stimulationDate: stimRow?.[dayKey] ?? '',
        surgeries: daySurgeries,
        surgeryDate: surgeryRow?.[dayKey] ?? '',

        //remark data
        treatment_remark: remarksData?.[0]?.[dayKey] ?? '',
        follow_up_advice: followUpAdvice?.[0]?.[dayKey] ?? '',
        mark_done_data: markDoneData?.[0]?.[dayKey] ?? '',

        //toxicity data
        toxicityRow: toxicityRow?.[`info${i}`]?.matches
          .map(t => {
            console.log(t)
            return {
              grade: t.grade,
              grade_info: t.grade_info
            };
          })
          .filter(x => x.grade) || [],

        // CLINICAL
        clinical: clinical
          .map(c => {
            const original = c.originalItems?.[i]; // optional fallback

            return {
              name: c.name,
              value: c[dayKey],

              //  ALL REQUIRED FIELDS
              uhId: original?.uhId || c.uhId,
              encounter_id: original?.encounter_id || c.encounter_id,
              itemCode: original?.itemCode || c.itemCode,
              hasFolliculogram: original?.hasFolliculogram ?? c.hasFolliculogram ?? false,
              day_no: i,
              serviceItemCode: original?.serviceItemCode || c.serviceItemCode,
              serviceItemId: original?.serviceItemId || c.serviceItemId,
              service_result: original?.service_result || c.service_result,
              GTV: original?.GTV || c.GTV || '',
              CTV: original?.CTV || c.CTV || '',
              PTV: original?.PTV || c.PTV || '',
            };
          })
          .filter(x => x.value),
        //  MEDICATION
        medication: medication
          .map(m => {
            console.log(m)
            const dayData = m[`id${i}`];

            return {
              //  COMMON DATA (row-wise)
              name: m.itemName,
              uhId: m.uhId,
              encounter_id: m.encounter_id,
              itemCode: m.itemCode,
              dose: m.dosage_no,
              time: this.getTime1(m.time),
              medicineCount: m.medicineCount,
              hide: m._hide,
              id: dayData?.id,
              itemData: m,
              dayIndex: i,
              qoh: m?.qoh,
              status: dayData?.status,
              stage: dayData?.stage,
              otherData: dayData?.other,
              administeredBy: dayData?.other?.administeredBy,
              //parent_id:dayData.parent_id?dayData.parent_id: this.patient_protocol_info.id,
              //start_date:dayData.start_date,
              administeredTime: dayData?.other?.administer_time,
              greaterThanCurrentDate: dayData?.greaterThanCurrentDate,
              infusion_order: dayData?.infusion_order || false,
              start_time: dayData?.start_time || 0,
              stop_time: dayData?.stop_time || 0,
              duration: dayData?.duration || 0,
              time_series: dayData?.time_series || []
            };
          })
          .filter(x => x.status)

      });
    }
    if (this.pullableView) {
      let labelData = [];
      labelData.push({
        clinical: {
          "Item Name": "name"
        },
        medication: {
          "Medication Name": "name",
          "Time": "time",
          "Dosage": "dose",
          "Infusion Rate": "infusion_rate",
          "Infusion Order": "infusion_order",
          "Status": "status",
          "Stage": "stage",
          "Grouping": "grouping",
          "Sequence": "sequence"
        },
        toxicityRow: ["grade", "grade_info"],
        "Treatment Remark": "treatment_remark",
        "Follow Up Advice": "follow_up_advice",
        "Sitting Status": "mark_done_data",
        "Date of Surgery": "surgeryDate",
        "Date of Sitting": "stimulationDate",
        //"Protocol Type": this.isChemoTherapy ? 'Chemotherapy' : (this.isRadiationTherapy ? 'Radiation Therapy' : '')
      })

      // labelData['remarkLabel'] =
      // {
      //   "Treatment Remark": "treatment_remark",
      //   "Follow Up Advice": "follow_up_advice",
      //   "Sitting Status": "mark_done_data"
      // }
      // labelData['Date of Surgery'] = "surgeryDate";

      let finalData = {};
      finalData['data'] = result;
      finalData['labels'] = labelData;
      if (this.isChemoTherapy)
        sessionStorage.setItem("chemo_pullable_protocol_data", JSON.stringify(finalData));
      if (this.isRadiationTherapy)
        sessionStorage.setItem("radio_pullable_protocol_data", JSON.stringify(finalData));
    }
    return result;
  }
  trackByDay(index: number, item: any): number {
    return Number(item?.day?.replace('Day ', '')) || index;
  }

  getMedicationTimes(day: any, name: string) {
    return day.medication?.filter(x => x.name === name);
  }


  getMobileActions(item) {
    const actions = this.checkPermission(this.capability());

    return actions.filter(action => {

      // if no condition → show
      if (!action.conditions) return true;

      // evaluate conditions like datagrid
      return action.conditions.some(cond => {
        try {
          return new Function('item', `return ${cond.expression}`)(item);
        } catch (e) {
          return false;
        }
      });

    });
  }
  executeCapability(action: any, item: any) {
    if (!action || !action.action) return;
    switch (action.action) {
      case 'popup_form':
        this.openPopupForm(action, item);
        break;

      case 'confirm':
        this.openConfirmPopup(action, item);
        break;

      default:
        console.warn('Unsupported capability:', action);
    }
  }
  openPopupForm(action: any, item: any) {
    const dayKey = `id${item?.dayIndex}`;
    const daywiseDataId = item?.itemData?.[dayKey]?.id;


    let payload = {
    };

    if (daywiseDataId) {
      payload['id'] = daywiseDataId
      payload = { ...payload, ...item?.itemData }
    }
    else {
      payload = { ...item }
      const currentUser = this.appService.getCurrentUser();
      const userType = currentUser?.user_type || '';
      payload['__user_type'] = userType
    }
    if ((action.api_action == "ADMINISTER" || action.api_action == "ADMINISTER_MEDICINE") && payload?.['stage'] == "Missed") {
      if (payload?.['reason']) {
        delete payload['reason'];
      }
    }
    console.log("FINAL PAYLOAD:", payload);

    this.smartModalService.open(DynamicPopUpComponent, {
      action: action,
      val: payload   // 
    }).subscribe(res => {
      if (res) this.dataCall();
    });
  }
  openConfirmPopup(action: any, item: any) {
    const dialogRef = this.modalService.confirmCustomBtn(
      action.title || 'Are you sure?',
      action.message || 'Do you want to continue?',
      'sm'
    );

    dialogRef.subscribe(result => {
      if (result) {
        this.executeApi(action, item);
      }
    });
  }
  executeApi(action: any, item: any) {
    this.loader.showSpinner();
    if (item?.itemData) {
      this.baseService.action(item.itemData, action.datasource.action, action.datasource.application, action.datasource.resource).subscribe({
        next: (res) => {
          this.loader.hideSpinner();

          if (res?.errCode === 0) {
            this.alerts.success('Success');
            this.dataCall(); // refresh
          } else {
            this.alerts.error(res?.message || 'Error');
          }
        },
        error: () => {
          this.loader.hideSpinner();
          this.alerts.error('Something went wrong');
        }
      });
    }
  }

  getStatusIcon(status: string): string {
    switch (status) {
      case 'Pending':
        return 'assets/images/emr/pending-icon.svg';

      case 'Hold':
        return 'assets/images/emr/hold-icon.svg';

      case 'Missed':
        return 'assets/images/emr/missed-icon.svg';

      case 'administer':
        return 'assets/images/emr/re-admin-icon.svg';

      case 'Given':
      case 'Completed':
        return 'assets/images/emr/admin-icon.svg';

      default:
        return '';
    }
  }

  getStatusActions(item) {
    if (this.viewOnly || this.from_History) {
      return;
    }
    const idKey = 'id' + item?.dayIndex;
    const cellData = item?.itemData?.[idKey];

    if (!cellData) return;

    const capabilities = this.getCapability();

    const actions = capabilities.filter(action => {
      if (!action.conditions) return true;

      return action.conditions.every(cond => {
        try {
          return new Function('item', `return ${cond.expression}`)(cellData);
        } catch (e) {
          return false;
        }
      });
    });

    return actions;
  }
  handleStatusPopover(popover: any, event: Event) {
    if (!popover) return;
    event.stopPropagation();
    // close previous status popover
    if (this.activeStatusPopover && this.activeStatusPopover !== popover) {
      this.activeStatusPopover.hide();
    }
    if (popover.isOpen) {
      popover.hide();
      this.activeStatusPopover = null;
    } else {
      popover.show();
      this.activeStatusPopover = popover;
    }
  }
  handleMenuPopover(popover: any, event: Event) {
    if (this.viewOnly || this.from_History || this.input == 'et_monitoring_chart') {
      return
    }
    event.stopPropagation();
    // this.activeStatusPopover=null
    if (this.activeStatusPopover) {
      this.activeStatusPopover.hide()
    }
    if (this.activeFlagPopover) {
      this.activeFlagPopover.hide()
    }

    // close previous menu popover
    if (this.activeMenuPopover && this.activeMenuPopover !== popover) {
      this.activeMenuPopover.hide();
    }

    if (popover.isOpen) {
      popover.hide();
      this.activeMenuPopover = null;
    } else {
      popover.show();
      this.activeMenuPopover = popover;
    }
  }
  getFlagString(flags) {
    if (flags.length == 0) {
      return ''
    }
    else {
      let textArr = flags.map((ele => ele.text))
      return textArr.join(", ")
    }
  }
  openFlagPopover(popover: any, event: Event) {
    event.stopPropagation();
    if (this.activeFlagPopover &&
      this.activeFlagPopover !== popover) {
      this.activeFlagPopover.hide();
    }
    if (this.activeStatusPopover) {
      this.activeStatusPopover.hide()
    }
    if (popover.isOpen) {
      popover.hide();
      this.activeFlagPopover = null;
    } else {
      popover.show();
      this.activeFlagPopover = popover;
    }
  }

  openStatusPopover(popover: any, event: Event) {
    event.stopPropagation();
    this.activeStatusPopover = popover
    if (this.activeFlagPopover) {
      this.activeFlagPopover.hide();
    }
  }
  handlePrint() {
    const templateName = this['input'] === 'et_monitoring_chart' ? 'etMonitoring' : (this['input'] === 'embryo_grading_format' || this['input'] === 'embryo_summary') ? 'embryoGradingSummary' : 'stimulationChart';
    const resourceName = this['input'] === 'et_monitoring_chart' ? 'embryo_chart_details' : (this['input'] === 'embryo_grading_format' || this['input'] === 'embryo_summary') ? 'embryo_grading' : 'stimulation_chart_details';
    // const cycleNo = this.cycle_no || this.apiData?.[0]?.cycle_no || this.patientDetails?.current_cycle || this.patientDetails?.cycle_no || '';
    // const carePlanId = this.care_plan_id || this.apiData?.[0]?.care_plan_id || this.patientDetails?.care_plan_id || '';

    const args = `uhId:${this.patientDetails?.uhId},reportTemplateId:${templateName},contentType:pdf`;

    const file_data: any = {
      template: templateName,
      resource: resourceName,
      application: 'emr',
      args: args,
      file_type: 'pdf',
      contentType: 'pdf'
    };

    const action = {
      action: 'print',
      file_data: file_data,
      isUserPrint: true,
      isNoOfPrintCopy: true
    };

    try {
      this.utilService.performPreprintAction(
        this.baseService,
        action,
        (res: any) => this.prePrint(action, args, res),
        (userPrintVal: any) => {
          const updatedArgs = `${args},userPrint:${userPrintVal}`;
          this.executePrint(action, updatedArgs);
        },
        templateName,
        false
      );
    } catch (err) {
      console.error("Unexpected error in performPreprintAction:", err);
      this.prePrint(action, args);
    }
  }

  prePrint(action: any, args: string, res?: any) {
    let printWithoutHF = this.appService._currentSessionData?.print_without_h_f;
    if (res && res.print_without_h_f != null) {
      printWithoutHF = res.print_without_h_f;
    }
    const defaultPrint = printWithoutHF ? "N" : "Y";

    let isNoOfPrintCopy = false;
    let override_print_copies = true;

    if (res?.no_of_print_copy > 1) {
      isNoOfPrintCopy = true;
    }
    if (res?.override_print_copies === true) {
      override_print_copies = false;
    }

    const prePrintForm = {
      title: "",
      form: {
        buttons: {
          Add: [
            {
              label: "Print",
              action: "prePrint"
            }
          ]
        },
        blocks: [
          {
            name: "pre_print",
            class_name: "null",
            layout_type: "no-column",
            order: 1,
            fields: [
              {
                label: "Select Print Header & Footer Type?",
                class_name: "kx-control col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6 fix",
                order: 2,
                type: "String",
                component: "dropdown",
                name: "userPrint",
                default: defaultPrint,
                datasource: {
                  possible_value: [
                    { id: "Y", value: "With Header & Footer" },
                    { id: "N", value: "Without Header & Footer" }
                  ]
                }
              },
              {
                label: "Select Layout Type?",
                class_name: "kx-control col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6 fix",
                order: 2,
                type: "String",
                component: "dropdown",
                name: "page_layout",
                default: "portrait",
                visible: true,
                datasource: {
                  possible_value: [
                    { id: "landscape", value: "Landscape" },
                    { id: "portrait", value: "Portrait" }
                  ]
                }
              },
              {
                label: "No of Print Copy",
                class_name: "kx-control col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6 fix",
                order: 3,
                type: "Integer",
                visible: isNoOfPrintCopy,
                disabled: override_print_copies,
                component: "numberbox",
                name: "no_of_print_copy",
                default: res?.no_of_print_copy ?? 1
              }
            ]
          }
        ]
      }
    };

    action.form = prePrintForm.form;
    const modalObj = { action, val: '' };

    const subscription = this.smartModalService.open(DynamicPopUpComponent, modalObj, prePrintForm.title || "", ModalSize.Md).subscribe({
      next: (resVal) => {
        subscription.unsubscribe();
        if (resVal && resVal.result && resVal.result.userPrint) {
          let updatedArgs = args;
          if (resVal.result.no_of_print_copy) {
            updatedArgs += `,no_of_print_copy:${resVal.result.no_of_print_copy}`;
          }
          if (resVal.result.userPrint) {
            updatedArgs += `,userPrint:${resVal.result.userPrint}`;
          }
          this.executePrint(action, updatedArgs);
        }
      },
      error: (err) => {
        subscription.unsubscribe();
        console.error("Modal closed with error:", err);
      }
    });
  }

  executePrint(action: any, args: string) {
    action.file_data.args = args;
    this.handleFile(action, { data: this.patientDetails });
  }
}
